import React, {
  useCallback,
  useEffect,
  useRef,
  useState,
  useMemo,
} from "react";
import {
  Button,
  Card,
  Form,
  Alert,
  Spinner,
  InputGroup,
  DropdownDivider,
} from "react-bootstrap";
import GeneralInfo from "./GeneralInfo";
import Stepper from "../../components/Stepper";
import BillingAndShippingForm from "./BillingAndShippingForm";
import OrderDetailsForm from "./OrderDetailsForm";
import { useNavigate } from "react-router-dom";
import moment from "moment";
import {
  IconArrowNarrowLeftDashed,
  IconArrowNarrowRightDashed,
  IconCloudUpload,
  IconInfoCircle,
} from "@tabler/icons-react";
import "./CreateLifeCycle.css";
import { useForm, FormProvider, useFormContext } from "react-hook-form";
import { useWatch } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import * as yup from "yup";
import usePostRequest from "../../hooks/usePostRequest";
import {
  API_ENDPOINTS,
  roundToMoney,
  truncateFormat,
} from "../../constant/_constant";
import { toast } from "react-toastify";
import Attachments from "./Attachments";
import { format } from "date-fns";
import SuccsessMsgModal from "../../components/SuccessMsgModal";
import {
  isValidPhoneNumber,
  parsePhoneNumberFromString,
} from "react-phone-number-input";
import { useSelector } from "react-redux";
import { useParams, useLocation, Link } from "react-router-dom";
import NotesSection from "./NotesSection";
import CustodyChainForm from "./CustodyChainForm";
import CustomerLifecycle from "./CustomerLifecycle";
import VendorForm from "./VendorForm";
import SalesLead from "./SalesLead_LifeCycle";
import ProductsSales from "./ProductsSales";
import { useNavigationGuard } from "../../hooks/useNavigationGuard";
import {
  generateChainOfCustody,
  InvoicedChain,
  paymentChain,
  trimTrailingZeros,
} from "../../utils/_helpers";
import useIdleLogout from "../../hooks/useIdleLogout";
import GsaPdfModal from "./GSAPDF/GsaPdfModal";
import { usePostHog } from "@posthog/react";

const PORT = process.env.REACT_APP_BASE_URL;

const generateUniqueId = () => {
  const characters =
    "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789";

  let result = "";
  for (let i = 0; i < 8; i++) {
    const randomIndex = Math.floor(Math.random() * characters.length);
    result += characters.charAt(randomIndex);
  }

  const timestamp = Date.now().toString();
  const uniqueId = result + timestamp.slice(-4);
  return uniqueId;
};

function CreateLifeCycle() {
  // const location = useLocation();
  // const { selectedCopy, orderCopy } = location.state || {};
  const location = useLocation();
  const [initialVal, setInitialVal] = useState(1);
  const [serverErr, setServerErr] = useState([]);
  const [show, setShow] = useState(false);
  const [isEditing, setIsEditing] = useState(false);
  const [orderDataFetched, setOrderDataFetched] = useState(false);
  const [orderDataFetchedcopy, setOrderDataFetchedcopy] = useState(false);
  const formIdRef = useRef(null);
  const [formId, setFormId] = useState(null);
  const [order_ref_type, setOrder_ref_type] = useState("");
  const [apiVendor, setApiVendor] = useState([]);
  const [contractEmails, setContractEmails] = useState([]);
  const [cvEmails, setCvEmails] = useState([]);
  // const [wonOpprqb, setWonOpprqb] = useState(null);
  const [singleOpprData, setSingleOpprData] = useState(null);
  const [orderId, setOrderId] = useState(null);
  const posthog = usePostHog();
  // const skipFirstEffect = useRef(false);

  const [isModalOpen, setIsModalOpen] = useState({
    show: false,
    message: "",
    btntext: "",
    title: "",
  });

  const [isPDFOpen, setIsPDFOpen] = useState({
    show: false,
  });

  const [rfqstatus, setRfqStatus] = useState();

  const handleStatusChange = (event) => {
    setRfqStatus(event.target.value);
  };

  const navigate = useNavigate();

  const user = useSelector((state) => state.auth.user);
  const allowedRoles = ["super-admin"];
  const isSuperAdmin = user?.roles?.some((role) => allowedRoles.includes(role));
  const isDeptHead = user?.is_department_head;
  const restrictedStatuses = ["PAID_CLOSED", "DELIVERED", "LOST_CANCELLED"];

  const canShowButtons =
    !restrictedStatuses.includes(rfqstatus) || isSuperAdmin || isDeptHead;

  const { order_id } = useParams();

  const updateFormId = (id) => {
    formIdRef.current = id;
    setFormId(id);
  };

  const schema = yup.object().shape({
    // step 1
    notes: yup.array().of(
      yup.object().shape({
        section: yup.string().required("Section is required"),
        notesdata: yup.array().of(
          yup.object().shape({
            note: yup.string().required("Note cannot be blank"),
          }),
        ),
      }),
    ),
    shipping_method: yup.string().optional(),
    shipping_method_detail: yup.string().nullable(),
    payment_term_detail: yup.string().nullable(),
    custom_fields: yup.array().of(
      yup.object().shape({
        field_name: yup.string().required("Field name is required"),
        value: yup.string().required("required"),
      }),
    ),

    // aVendors: yup.array().of(
    //   yup.object().shape({
    //     display_name: yup
    //       .string()
    //       .transform((value) => (value === "" ? null : value))
    //       .nullable()
    //       .min(2, "Must be at least 2 character")
    //       .max(100, "Must be at most 100 characters"),
    //   })
    // ),

    // ProjectID: yup.string().required("Project Id is required"),
    ProjectID: yup
      .string()
      .transform((value) => (value === "" ? null : value))
      .nullable(),
    // orderId: yup.string().required("Order Id is required"),
    orderId: yup
      .string()
      .matches(
        /^[a-zA-Z0-9/ .\-–—]+$/,
        "Order Id can contain only letters, numbers, spaces, /, -, – , — and dots",
      )
      .required("Order Id is required"),
    // orderId: yup
    //   .string()
    //   // .trim()
    //   .matches(/^[\S/]+$/, "Order Id cannot contain spaces")
    //   .matches(
    //     /^[a-zA-Z0-9/]+$/,
    //     "Order Id can contain only letters, numbers, and /"
    //   )
    //   .required("Order Id is required"),

    ordertype: yup.string().required("Order Type is required"),
    order_Payment_Type: yup.string().required("Order Payment Type is required"),
    contractVehicle: yup
      .number()
      .transform((value) => (value === "" ? null : value))
      .typeError("Contract Vehicle required.")
      .required("Contract Vehicle required.")
      .test("is-valid-number", "not nagetive.", (value) => {
        return value === null || (!isNaN(value) && value !== -1);
      }),

    publishedDate: yup.date().required("Published Date is required"),
    estimated_date: yup
      .date()
      .transform((value, originalValue) => {
        return originalValue === "" ? undefined : value;
      })
      .nullable()
      .required("Estimated Date is required"),

    actual_date: yup
      .date()
      .transform((value, originalValue) => {
        return originalValue === "" ? undefined : value;
      })
      .nullable()
      .optional(),

    // order_id: yup.date().required("Due Date is required"),

    organization_name: yup
      .string()
      .transform((value) => (value === "" ? null : value))
      .nullable()
      .min(2, "Must be at least 2 character")
      .max(100, "Must be at most 100 characters"),

    Order_Description: yup
      .string()
      .transform((value) => (value === "" ? null : value))
      .nullable()
      .min(5, "Must be at least 5 characters")
      .max(500, "Must be at most 500 characters"),
    Valid_For: yup.string().nullable(),

    //  step 2
    estimateddelivery: yup.string().nullable(false).notRequired(),
    payment_terms: yup.string().optional(),
    shipping_method: yup.string().optional(),
    trackingNumber: yup.string().optional(),
    amendment: yup.string().optional(),
    purchaseOrder: yup.string().optional(),
    deliveryOrder: yup.string().optional(),
    carrier: yup.string().optional(),
    shipDate: yup
      .date()
      .transform((value, originalValue) => {
        return originalValue === "" ? undefined : value;
      })
      .nullable()
      .optional(),
    // shippingCostPacking: yup
    //   .number()
    //   .transform((value) => (value === "" ? null : value)),
    contractOfficerName: yup.string().nullable(),
    contractOfficerEmail: yup
      .string()
      .nullable()
      .email("Email must be a valid email address"),
    // contractOfficerPhone: yup
    //   .string()
    //   .transform((value) => (value === "" ? null : value))
    //   .nullable()
    //   .min(10, "Phone number must be at least 10 digits")
    //   .optional(),
    contractOfficerPhone: yup
      .string()
      .transform((value) => (value === "" ? null : value))
      .nullable(),
    // .test("valid-phone", "Invalid phone number", (value) => {
    //   if (!value) {
    //     return true;
    //   }
    //   if (typeof value === "string" && value.trim() !== "") {
    //     return isValidPhoneNumber(value);
    //   }
    //   return false;
    // })
    // .optional(),
    contractOfficerAddress: yup.string().nullable(),
    shippingCustomerName: yup.string().nullable(),
    shippingCustomerEmail: yup
      .string()
      .nullable()
      .email("Email must be a valid email address"),
    shippingCustomerPhone: yup
      .string()
      .transform((value) => (value === "" ? null : value))
      .nullable(),
    orderpending_notification_emails: yup
      .array()
      .of(yup.string().email("Invalid email")),

    orderprogress_notification_emails: yup
      .array()
      .of(yup.string().email("Invalid email")),
    // .test("valid-phone", "Invalid phone number", (value) => {
    //   if (!value) {
    //     return true;
    //   }
    //   if (typeof value === "string" && value.trim() !== "") {
    //     return isValidPhoneNumber(value);
    //   }
    //   return false;
    // })
    // .optional(),
    shippingCustomerAddress: yup.string().nullable(),
    BillingCustomerName: yup.string().nullable(),
    BillingCustomerEmail: yup
      .string()
      .nullable()
      .email("Email must be a valid email address"),
    BillingCustomerPhone: yup
      .string()
      .transform((value) => (value === "" ? null : value))
      .nullable(),
    // .test("valid-phone", "Invalid phone number", (value) => {
    //   if (!value) {
    //     return true;
    //   }
    //   if (typeof value === "string" && value.trim() !== "") {
    //     return isValidPhoneNumber(value);
    //   }

    //   return false;
    // })
    // .optional(),
    // BillingCustomerPhone: yup
    //   .string()
    //   .transform((value) => (value === "" ? null : value))
    //   .nullable()
    //   .min(10, "Phone number must be at least 10 digits")
    //   .optional(),
    BillingCustomerAddress: yup.string().nullable(),

    // sales lead
    // sales_lead_username: yup.string().required("Sales Lead Username is required")

    sales_lead_name: yup.string().required("Sales Lead Name is required"),
    sales_lead_email: yup
      .string()
      .email("Email must be a valid email address")
      .required("Sales Lead Email is required"),
    sales_lead_phone: yup
      .string()
      .transform((value) => (value === "" ? null : value))
      .min(10, "Phone number must be at least 10 digits")
      .required("Sales Lead Phone is required"),
    notification_emails: yup.array().of(yup.string().email("Invalid email")),

    // Notes: yup.array().of(
    //   yup.object().shape({
    //     description: yup
    //       .string()
    //       .transform((value) => (value === "" ? null : value))
    //       .nullable()
    //       .min(10, "Description must be at least 10 characters")
    //       .max(200, "Description must be at most 200 characters")
    //       .optional(),
    //   })
    // ),

    otherCost: yup.array().of(
      yup.object({
        Name: yup.string().required(),
        Amount: yup
          .number()
          .transform((value) => (value === "" ? null : value))
          .typeError("Must be a number.")
          .required("required.")
          .test("is-valid-number", "not nagetive.", (value) => {
            return value === null || (!isNaN(value) && value !== -1);
          })
          .min(1, "at least 1."),
      }),
    ),

    otherCostSales: yup.array().of(
      yup.object({
        Name: yup.string().required(),
        Amount: yup
          .number()
          .transform((value) => (value === "" ? null : value))
          .typeError("Must be a number.")
          .required("required.")
          .test("is-valid-number", "not nagetive.", (value) => {
            return value === null || (!isNaN(value) && value !== -1);
          })
          .min(1, "at least 1."),
      }),
    ),

    cards: yup.array().when(["ordertype", "hasKitProducts"], {
      is: (ordertype, hasKitProducts) =>
        ordertype === "KIT" && hasKitProducts === true,
      then: (schema) =>
        schema.of(
          yup.object({
            vendorPartner: yup.string().required("required."),
            skuId: yup.string().min(1, "required.").required("required."),
            productName: yup.string().nullable().optional(),
            skuDescription: yup.string().nullable(),
            cost: yup
              .number()
              .transform((value) =>
                value === "" || isNaN(value) ? null : value,
              )
              .typeError("Must be a number.")
              .required("required.")
              .test(
                "is-valid-number",
                "not negative.",
                (value) => value === null || (!isNaN(value) && value >= 0),
              )
              // .min(0.01, "at least 0.01."),
              .moreThan(0, "Must be greater than 0."),
            qty: yup
              .number()
              .transform((value) =>
                value === "" || isNaN(value) ? null : value,
              )
              .typeError("Must be a number.")
              .required("required.")
              .test(
                "is-valid-number",
                "not negative.",
                (value) => value === null || (!isNaN(value) && value >= 0),
              )
              .min(1, "at least 1."),
            margin: yup
              .number()
              .transform((value) =>
                value === "" || isNaN(value) ? null : value,
              )
              .typeError("Must be a number."),
            // margin: yup
            //   .number()
            //   .transform((value) =>
            //     value === "" || isNaN(value) ? null : value,
            //   )
            //   .typeError("Must be a number.")
            //   .test(
            //     "is-valid-number",
            //     "not negative.",
            //     (value) => value === null || (!isNaN(value) && value >= 0),
            //   )
            //   .min(0, "Minimum 0%."),
            customerCost: yup
              .number()
              .transform((value) =>
                value === "" || isNaN(value) ? null : value,
              )
              .typeError("Must be a number.")
              .required("required.")
              .test(
                "is-valid-number",
                "not negative.",
                (value) => value === null || (!isNaN(value) && value >= 0),
              ),
            um: yup.string().nullable(),
          }),
        ),
      otherwise: () =>
        yup.array().of(
          yup.object({
            vendorPartner: yup.string().nullable(),
            skuId: yup.string().nullable(),
            productName: yup.string().nullable().optional(),
            skuDescription: yup.string().nullable(),
            cost: yup
              .number()
              .transform((value) =>
                value === "" || isNaN(value) ? null : value,
              )
              .typeError("Must be a number.")
              .nullable(),
            qty: yup
              .number()
              .transform((value) =>
                value === "" || isNaN(value) ? null : value,
              )
              .typeError("Must be a number.")
              .nullable(),
            margin: yup
              .number()
              .transform((value) =>
                value === "" || isNaN(value) ? null : value,
              )
              .typeError("Must be a number."),
            // margin: yup
            //   .number()
            //   .transform((value) =>
            //     value === "" || isNaN(value) ? null : value,
            //   )
            //   .typeError("Must be a number.")
            //   .nullable(),
            customerCost: yup
              .number()
              .transform((value) =>
                value === "" || isNaN(value) ? null : value,
              )
              .typeError("Must be a number.")
              .nullable(),
            um: yup.string().nullable(),
          }),
        ),
    }),

    // cards: yup.array().when("ordertype", ([ordertype], schema) => {
    //   if (ordertype === "CRK") {
    //     return schema.of(
    //       yup.object({
    //         vendorPartner: yup.string().required("required."),
    //         skuId: yup.string().min(1, "required.").required("required."),
    //         skuDescription: yup.string().nullable(),
    //         cost: yup
    //           .number()
    //           .transform((value) => (value === "" ? null : value))
    //           .typeError("Must be a number.")
    //           .required("required.")
    //           .test("is-valid-number", "not negative.", (value) => {
    //             return value === null || (!isNaN(value) && value !== -1);
    //           })
    //           .min(1, "at least 1."),
    //         qty: yup
    //           .number()
    //           .transform((value) => (value === "" ? null : value))
    //           .typeError("Must be a number.")
    //           .required("required.")
    //           .test("is-valid-number", "not negative.", (value) => {
    //             return value === null || (!isNaN(value) && value !== -1);
    //           })
    //           .min(1, "at least 1."),
    //         margin: yup
    //           .number()
    //           .transform((value) => (value === "" ? null : value))
    //           .typeError("Must be a number.")
    //           .test("is-valid-number", "not negative.", (value) => {
    //             return value === null || (!isNaN(value) && value !== -1);
    //           })
    //           .min(0, "Minimum 0%."),
    //         customerCost: yup
    //           .number()
    //           .transform((value) => (value === "" ? null : value))
    //           .typeError("Must be a number.")
    //           .required("required.")
    //           .test("is-valid-number", "not negative.", (value) => {
    //             return value === null || (!isNaN(value) && value !== -1);
    //           }),
    //         um: yup.string().nullable(),
    //       })
    //     );
    //   }
    //   return yup.array().notRequired(); // No validation if not CRK
    // }),

    // cards: yup.array().of(
    //   yup.object({
    //     vendorPartner: yup.string().required("required."),
    //     skuId: yup.string().min(1, "required.").required("required."),
    //     skuDescription: yup.string().nullable(),
    //     // .required("Description is required.")
    //     // .min(5, "Description must be at least 5 characters."),
    //     // salesDescription: yup
    //     //   .string()
    //     //   .required("Description is required.")
    //     //   .min(5, "Description must be at least 5 characters."),
    //     // .max(100, "Description must be at most 100 characters."),
    //     cost: yup
    //       .number()
    //       .transform((value) => (value === "" ? null : value))
    //       .typeError("Must be a number.")
    //       .required("required.")
    //       .test("is-valid-number", "not nagetive.", (value) => {
    //         return value === null || (!isNaN(value) && value !== -1);
    //       })
    //       .min(1, "at least 1."),
    //     qty: yup
    //       .number()
    //       .transform((value) => (value === "" ? null : value))
    //       .typeError("Must be a number.")
    //       .required("required.")
    //       .test("is-valid-number", "not nagetive.", (value) => {
    //         return value === null || (!isNaN(value) && value !== -1);
    //       })
    //       .min(1, "at least 1."),
    //     margin: yup
    //       .number()
    //       .transform((value) => (value === "" ? null : value))
    //       .typeError("Must be a number.")
    //       // .required("required.")
    //       .test("is-valid-number", "not nagetive.", (value) => {
    //         return value === null || (!isNaN(value) && value !== -1);
    //       })
    //       .min(0, "Minimum 0%."),
    //     customerCost: yup
    //       .number()
    //       .transform((value) => (value === "" ? null : value))
    //       .typeError("Must be a number.")
    //       .required("required.")
    //       .test("is-valid-number", "not nagetive.", (value) => {
    //         return value === null || (!isNaN(value) && value !== -1);
    //       }),
    //     um: yup.string().required("Unit of Measure is required."),
    //   })
    // ),

    product_sales: yup.array().of(
      yup.object({
        vendorPartner: yup.string().required("required."),
        skuId: yup.string().min(1, "required.").required("required."),
        productName: yup.string().nullable().optional(),
        clin: yup.string().nullable().optional(),
        skuDescription: yup.string().nullable(),
        // .required("Description is required.")
        // .min(5, "Description must be at least 5 characters."),
        // .max(100, "Description must be at most 100 characters."),
        cost: yup
          .number()
          .transform((value) => (value === "" ? null : value))
          .typeError("Must be a number.")
          .required("required.")
          .test("is-valid-number", "not nagetive.", (value) => {
            return value === null || (!isNaN(value) && value !== -1);
          })
          // .min(1, "at least 1."),
          .moreThan(0, "Must be greater than 0."),

        qty: yup
          .number()
          .transform((value) => (value === "" ? null : value))
          .typeError("Must be a number.")
          .required("Quantity is required.")
          .min(1, "Quantity must be at least 1.")
          .test(
            "max-qty",
            "Quantity cannot exceed available quantity.",
            function (value) {
              const { max_quantity } = this.parent;
              if (value == null) return true;
              if (max_quantity == null) return true;
              if (value <= max_quantity) return true;
              return this.createError({
                message: `Maximum allowed quantity is ${max_quantity}`,
              });
            },
          ),
        margin: yup
          .number()
          .transform((value) => (value === "" || isNaN(value) ? null : value))
          .typeError("Must be a number."),
        // margin: yup
        //   .number()
        //   .transform((value) => (value === "" ? null : value))
        //   .typeError("Must be a number.")
        //   // .required("required.")
        //   .test("is-valid-number", "not nagetive.", (value) => {
        //     return value === null || (!isNaN(value) && value !== -1);
        //   })
        //   .min(0, "Minimum 0%."),
        customerCost: yup
          .number()
          .transform((value) => (value === "" ? null : value))
          .typeError("Must be a number.")
          .required("required.")
          .test("is-valid-number", "not nagetive.", (value) => {
            return value === null || (!isNaN(value) && value !== -1);
          }),
        um: yup.string().nullable(),
      }),
    ),
  });

  // const onCopyOrderSuccess = (res) => {
  //   selectedCopy.forEach((field) => {
  //     switch (field) {
  //       case "Order Type":
  //         setValue(
  //           "ordertype",
  //           res?.data?.order_type ? res?.data?.order_type : ""
  //         );
  //         break;
  //       case "Contract Vehicle":
  //         setValue(
  //           "contractVehicle",
  //           res?.data?.contract_type_id ? res?.data?.contract_type_id : null
  //         );
  //         break;
  //       case "Organization Name":
  //         setValue(
  //           "organization_name",
  //           res?.data?.organization_name ? res?.data?.organization_name : ""
  //         );
  //         break;
  //       case "Order Description":
  //         setValue("Order_Description", res?.data?.brief);
  //         break;
  //       case "Date Created":
  //         setValue(
  //           "publishedDate",
  //           res?.data?.published_date
  //             ? moment(res?.data?.published_date).format("MM/DD/YYYY")
  //             : null
  //         );
  //         break;
  //       case "Estimated Date Fulfilled":
  //         setValue(
  //           "Estimated Date Fulfilled",
  //           res?.data?.estimated_date
  //             ? moment(res?.data?.estimated_date).format("MM/DD/YYYY")
  //             : ""
  //         );
  //         break;
  //       case "Estimated Date Fulfilled":
  //         setValue(
  //           "Estimated Date Fulfilled",
  //           res?.data?.estimated_date
  //             ? moment(res?.data?.estimated_date).format("MM/DD/YYYY")
  //             : ""
  //         );
  //         break;
  //       case "Estimated Date Fulfilled":
  //         setValue(
  //           "Estimated Date Fulfilled",
  //           res?.data?.estimated_date
  //             ? moment(res?.data?.estimated_date).format("MM/DD/YYYY")
  //             : ""
  //         );
  //         break;
  //       case "Actual Date Fulfilled":
  //         setValue(
  //           "actual_date",
  //           res?.data?.actual_date
  //             ? moment(res?.data?.actual_date).format("MM/DD/YYYY")
  //             : ""
  //         );
  //         break;
  //       case "Custom fields":
  //         setValue("custom_fields", res?.data?.custom_fields || []);
  //         break;
  //       case "chain of custody":
  //         setValue("chainOfCustody", res?.data?.OrderChainOfCustodies);
  //         break;

  //       case "Contracting Name":
  //         setValue(
  //           "contractOfficerName",
  //           res?.data?.orderKo?.name ? res?.data?.orderKo?.name : ""
  //         );
  //         break;
  //       case "Contracting Email":
  //         setValue(
  //           "contractOfficerEmail",
  //           res?.data?.orderKo?.email ? res?.data?.orderKo?.email : ""
  //         );
  //       case "Contracting Phone":
  //         setValue(
  //           "contractOfficerPhone",
  //           res?.data?.orderKo?.phone ? res?.data?.orderKo?.phone : ""
  //         );
  //         break;
  //       case "Contracting Address":
  //         setValue(
  //           "contractOfficerAddress",
  //           res?.data?.orderKo?.address ? res?.data?.orderKo?.address : ""
  //         );
  //         break;
  //       case "Shipping Name":
  //         setValue(
  //           "shippingCustomerName",
  //           res?.data?.rfqShipping?.name ? res?.data?.rfqShipping?.name : ""
  //         );
  //         break;
  //       case "Shipping Phone":
  //         setValue(
  //           "shippingCustomerPhone",
  //           res?.data?.rfqShipping?.phone ? res?.data?.rfqShipping?.phone : ""
  //         );
  //         break;
  //       case "Shipping Email":
  //         setValue(
  //           "shippingCustomerEmail",
  //           res?.data?.rfqShipping?.email ? res?.data?.rfqShipping?.email : ""
  //         );
  //         break;
  //       case "Shipping Address":
  //         setValue(
  //           "shippingCustomerAddress",
  //           res?.data?.rfqShipping?.address
  //             ? res?.data?.rfqShipping?.address
  //             : ""
  //         );
  //         break;

  //       case "Billing Name":
  //         setValue(
  //           "BillingCustomerName",
  //           res?.data?.rfqBilling?.name ? res?.data?.rfqBilling?.name : ""
  //         );
  //         break;
  //       case "Billing Email":
  //         setValue(
  //           "BillingCustomerEmail",
  //           res?.data?.rfqBilling?.email ? res?.data?.rfqBilling?.email : ""
  //         );
  //         break;
  //       case "Billing Phone":
  //         setValue(
  //           "BillingCustomerPhone",
  //           res?.data?.rfqBilling?.phone ? res?.data?.rfqBilling?.phone : ""
  //         );
  //         break;
  //       case "Billing Address":
  //         setValue(
  //           "BillingCustomerAddress",
  //           res?.data?.rfqBilling?.address ? res?.data?.rfqBilling?.address : ""
  //         );
  //         break;
  //       case "Shipping Method":
  //         setValue(
  //           "shipping_method",
  //           res?.data?.shipping_method ? res?.data?.shipping_method : ""
  //         );
  //         break;
  //       case "Shipping Terms":
  //         setValue(
  //           "shipping_terms",
  //           res?.data?.shipping_terms ? res?.data?.shipping_terms : ""
  //         );
  //         break;
  //       case "Payment Terms":
  //         setValue(
  //           "payment_terms",
  //           res?.data?.payment_term ? res?.data?.payment_term : ""
  //         );
  //         break;
  //       case "Estimated Delivery":
  //         setValue(
  //           "estimateddelivery",
  //           res?.data?.estimated_delivery ? res?.data?.estimated_delivery : null
  //         );
  //         break;
  //       case "Shipping Cost($)":
  //         setValue(
  //           "shippingCost",
  //           res?.data?.shipping_cost ? res?.data?.shipping_cost : null
  //         );
  //         break;
  //       case "Tax($)":
  //         setValue("tax", res?.data?.tax);
  //         break;
  //       case "Other Cost":
  //         const parsedCosts = res?.data?.other_cost_json
  //           ? JSON.parse(res.data.other_cost_json)
  //           : [];
  //         parsedCosts.forEach((cost, index) => {
  //           setValue(`otherCost[${index}].Name`, cost?.Name);
  //           setValue(`otherCost[${index}].Amount`, cost?.Amount);
  //         });
  //         break;
  //       case "Total Cost Before Margin($)":
  //         setValue(
  //           "totalCostBeforeMargin",
  //           res?.data?.total_cost_before_margin
  //         );
  //         break;
  //       case "Total Cost After Margin($)":
  //         setValue("totalCostAfterMargin", res?.data?.total_cost_after_margin);
  //         break;
  //       case "Total Cost After Margin($)":
  //         setValue("totalCostAfterMargin", res?.data?.total_cost_after_margin);
  //         break;
  //       case "Product":
  //         res?.data?.OrderProducts.forEach((product, index) => {
  //           console.log("product", product);

  //           setValue(`cards[${index}].skuDescription`, product?.description);
  //           setValue(
  //             `cards[${index}].vendorPartner`,
  //             product?.Vendor?.display_name
  //           );
  //           setValue(`cards[${index}].skuId`, product?.sku_id);
  //           setValue(`cards[${index}].cost`, product?.aspetto_price);
  //           setValue(`cards[${index}].margin`, product?.margin_percent);
  //           setValue(`cards[${index}].qty`, product?.quantity);
  //           setValue(`cards[${index}].um`, product?.unit_of_measure);
  //           setValue(`cards[${index}].customerCost`, product?.customer_price);
  //           setValue(`cards[${index}].totalSkuCost`, product?.total_price);
  //         });
  //         break;
  //       case "Product":
  //         res?.data?.OrderProducts.forEach((product, index) => {
  //           setValue(`cards[${index}].skuDescription`, product?.description);
  //           setValue(
  //             `cards[${index}].vendorPartner`,
  //             product?.Vendor?.display_name
  //           );
  //           setValue(`cards[${index}].skuId`, product?.sku_id);
  //           setValue(`cards[${index}].cost`, product?.aspetto_price);
  //           setValue(`cards[${index}].margin`, product?.margin_percent);
  //           setValue(`cards[${index}].qty`, product?.quantity);
  //           setValue(`cards[${index}].um`, product?.unit_of_measure);
  //           setValue(`cards[${index}].customerCost`, product?.customer_price);
  //           setValue(`cards[${index}].totalSkuCost`, product?.total_price);
  //         });
  //         break;
  //       // case "Order Vendor":
  //       //   res?.data?.OrderVendors.forEach((vendor, index) => {
  //       //     setValue(
  //       //       `aVendors[${index}].display_name`,
  //       //       vendor?.Vendor?.display_name
  //       //     );
  //       //     setValue(`aVendors[${index}].ko_name`, vendor?.ko_name);
  //       //     setValue(`aVendors[${index}].ko_email`, vendor?.ko_email);
  //       //     setValue(`aVendors[${index}].ko_phone`, vendor?.ko_phone);
  //       //   });
  //       //   break;
  //       default:
  //         break;
  //     }
  //   });
  // };

  useIdleLogout();

  const transformData = (resData) => {
    return {
      notes: resData.map((section) => ({
        section: section.name,
        custom_id: section.custom_id,
        notesdata: section.notes.map((noteItem) => ({
          note: noteItem.note,
          user: noteItem.User.username,
          updateAt: noteItem.updated_at,
          custom_id: noteItem.custom_id || undefined,
        })),
      })),
    };
  };

  const onSingleNotesSuccess = (res) => {
    if (res?.data) {
      const transformedData = transformData(res.data);
      setValue("notes", transformedData.notes);
    }
  };

  // const onRmaIdError = (err) => {
  //   reset({
  //     ProjectID: getValues("orderId"),
  //     // chainOfCustody: getValues("chainOfCustody"),
  //   });

  //   toast.error(err?.message);
  // };

  const onRmaIdSuccess = (res) => {
    if (res?.data) {
      if (res?.data?.rma_type !== "EXCHANGE") {
        toast.error(
          "The order with this Order ID is either not filed for EXCHANGE or does not exist.",
        );
        setValue("orderId", "");
        setValue("ordertype", "");
        setValue("publishedDate", null);
        setValue("estimated_date", null);
        setValue("actual_date", null);
        setValue("organization_name", "");
        setValue("estimatedDate", null);
        setValue("Order_Description", "");
        return;
      }
      // console.log("order_ref_type", res?.order_ref_type)
      setOrder_ref_type(res?.order_ref_type);
      setValue(
        "contractVehicle",
        res?.data?.contract_type_id ? res?.data?.contract_type_id : null,
      );
      setValue(
        "cv_rfq_id",
        res?.data?.ContractType?.cv_rfq?.id
          ? res?.data?.ContractType?.cv_rfq?.id
          : null,
      );
      // setValue("orderId", res?.order_id ? res?.order_id : "N/A");
      setValue(
        "organization_name",
        res?.data?.organization_name ? res?.data?.organization_name : "",
      );
      setValue(
        "publishedDate",
        res?.data?.published_date
          ? moment(res?.data?.published_date).format("MM/DD/YYYY")
          : null,
      );
      setValue(
        "estimated_date",
        res?.data?.estimated_date
          ? moment(res?.data?.estimated_date).format("MM/DD/YYYY")
          : null,
      );
      setValue(
        "actual_date",
        res?.data?.actual_date
          ? moment(res?.data?.actual_date).format("MM/DD/YYYY")
          : null,
      );
      setValue("Order_Description", res?.data?.brief);
      setValue(
        "payment_terms",
        res?.data?.payment_term ? res?.data?.payment_term : "",
      );
      setValue(
        "shipping_method",
        res?.data?.shipping_method ? res?.data?.shipping_method : "",
      );
      setValue(
        "shipping_terms",
        res?.data?.shipping_term ? res?.data?.shipping_term : "",
      );

      setValue(
        "contractOfficerName",
        res?.data?.rmaKo?.name ? res?.data?.rfqKo?.name : "",
      );
      setValue(
        "contractOfficerEmail",
        res?.data?.rmaKo?.email ? res?.data?.rfqKo?.email : "",
      );
      setValue(
        "contractOfficerPhone",
        res?.data?.rmaKo?.phone ? res?.data?.rfqKo?.phone : "",
      );
      setValue(
        "contractOfficerAddress",
        res?.data?.rmaKo?.address ? res?.data?.rfqKo?.address : "",
      );
      setValue(
        "shippingCustomerName",
        res?.data?.rmaShipping?.name ? res?.data?.rfqShipping?.name : "",
      );
      setValue(
        "shippingCustomerPhone",
        res?.data?.rmaShipping?.phone ? res?.data?.rfqShipping?.phone : "",
      );
      setValue(
        "shippingCustomerEmail",
        res?.data?.rmaShipping?.email ? res?.data?.rfqShipping?.email : "",
      );
      setValue(
        "shippingCustomerAddress",
        res?.data?.rmaShipping?.address ? res?.data?.rfqShipping?.address : "",
      );

      setValue(
        "BillingCustomerName",
        res?.data?.rfqBilling?.name ? res?.data?.rfqBilling?.name : "",
      );
      setValue(
        "BillingCustomerEmail",
        res?.data?.rfqBilling?.email ? res?.data?.rfqBilling?.email : "",
      );
      setValue(
        "BillingCustomerPhone",
        res?.data?.rfqBilling?.phone ? res?.data?.rfqBilling?.phone : "",
      );
      setValue(
        "BillingCustomerAddress",
        res?.data?.rfqBilling?.address ? res?.data?.rfqBilling?.address : "",
      );

      setRfqStatus(res?.data?.status);
      // if (res?.data?.attachment_id) {
      //   setFormId(res?.data?.attachment_id);
      // }
      setValue(
        "sameShipNameasKO",
        res?.data?.is_shipping_same_ko ? res?.data?.is_shipping_same_ko : "",
      );
      setValue(
        "sameBillNameasKO",
        res?.data?.is_billing_same_ko ? res?.data?.is_billing_same_ko : "",
      );

      // setRfqStatus(res?.data?.status);
      // if (res?.data?.attachment_id) {
      //   setFormId(res?.data?.attachment_id);
      // }

      setValue("Warehouse", res?.data?.initial_consolidation === 1 ? "1" : "0");

      // card  //
      res?.data?.RmaProducts.forEach((product, index) => {
        setValue(`cards[${index}].skuDescription`, product?.description);
        setValue(
          `cards[${index}].vendorPartner`,
          product?.Vendor?.display_name,
        );
        setValue(`cards[${index}].skuId`, product?.sku_id);
        setValue(`cards[${index}].productName`, product?.name);
        setValue(
          `cards[${index}].cost`,
          trimTrailingZeros(product?.aspetto_price),
        );
        setValue(
          `cards[${index}].margin`,
          trimTrailingZeros(product?.margin_percent),
        );
        setValue(`cards[${index}].qty`, trimTrailingZeros(product?.quantity));
        setValue(`cards[${index}].um`, product?.unit_of_measure);
        setValue(`cards[${index}].customerCost`, product?.customer_price);
        setValue(`cards[${index}].totalSkuCost`, product?.total_price);
      });

      const parsedCosts = res?.data?.other_cost_json
        ? JSON.parse(res.data.other_cost_json)
        : [];
      parsedCosts.forEach((cost, index) => {
        setValue(`otherCost[${index}].Name`, cost?.Name);
        setValue(`otherCost[${index}].Amount`, cost?.Amount);
      });
      setValue("tax", res?.data?.tax);
      setValue("shippingCost", res?.data?.shipping_cost);
      setValue("totalCostAfterMargin", res?.data?.total_cost_after_margin);
      setValue("totalCostBeforeMargin", res?.data?.total_cost_before_margin);
    } else {
      // reset({
      //   ProjectID: getValues("ProjectID"),
      //   chainOfCustody: getValues("chainOfCustody"),
      // });
      const currentProjectID = getValues("ProjectID");
      const currentchainOfCustody = getValues("chainOfCustody");
      reset();
      setValue("chainOfCustody", currentchainOfCustody);
      setValue("ProjectID", currentProjectID);
      //setValue("contractVehicle", null);
    }
  };

  const onSingleOrderSuccess = (res) => {
    if (res?.data) {
      setValue("ordertype", res?.data?.order_type ? res?.data?.order_type : "");
      setValue("orderStatus", res?.data?.status ? res?.data?.status : "");
      setValue(
        "order_Payment_Type",
        res?.data?.order_payment_type ? res?.data?.order_payment_type : "",
      );
      setValue("orderId", res?.data?.order_id ? res?.data?.order_id : "");

      setValue(
        "customerPaid",
        res?.data?.customer_paid ? res?.data?.customer_paid : "",
      );

      setValue(
        "contractVehicle",
        res?.data?.contract_type_id ? res?.data?.contract_type_id : null,
      );

      setValue(
        "cv_rfq_id",
        res?.data?.ContractType?.cv_rfq?.id
          ? res?.data?.ContractType?.cv_rfq?.id
          : null,
      );

      setValue("vehicleId", res?.data?.ContractType?.id);

      setValue(
        "contractVehicletype",
        res?.data?.ContractType?.contract_vehicle_type
          ? res?.data?.ContractType?.contract_vehicle_type
          : null,
      );

      setValue(
        "shipping_method_detail",
        res?.data?.shipping_method_detail
          ? res?.data?.shipping_method_detail
          : null,
      );
      setValue(
        "ProjectID",
        res?.data?.project_id ? res?.data?.project_id : null,
      );
      setValue(
        "organization_name",
        res?.data?.organization_name ? res?.data?.organization_name : "",
      );
      setValue("Order_Description", res?.data?.brief);
      setValue(
        "publishedDate",
        res?.data?.published_date
          ? moment(res?.data?.published_date).format("MM/DD/YYYY")
          : null,
      );
      setValue(
        "estimated_date",
        res?.data?.estimated_date
          ? moment(res?.data?.estimated_date).format("MM/DD/YYYY")
          : "",
      );
      setValue(
        "actual_date",
        res?.data?.actual_date
          ? moment(res?.data?.actual_date).format("MM/DD/YYYY")
          : "",
      );

      // setValue("custom_fields", res?.data?.custom_fields || []);
      const transformedCustomFields = (res?.data?.custom_fields || []).map(
        (field) => {
          if (field.type === "date" && field.value) {
            return {
              ...field,
              value: moment(field.value).format("MM/DD/YYYY"),
            };
          }
          return field;
        },
      );
      setValue("custom_fields", transformedCustomFields);

      setValue("trackingNumber", res?.data?.orderExtra?.tracking_number || "");
      setValue("carrier", res?.data?.orderExtra?.carrier || "");
      setValue("purchaseOrder", res?.data?.orderExtra?.purchase_order || "");
      setValue("deliveryOrder", res?.data?.orderExtra?.delivery_order || "");
      setValue("amendment", res?.data?.orderExtra?.amendment || "");
      setValue(
        "shipDate",
        res?.data?.orderExtra?.ship_date
          ? moment(res?.data?.orderExtra?.ship_date).format("MM/DD/YYYY")
          : null,
      );
      setValue(
        "shippingCostPacking",
        res?.data?.orderExtra?.shipping_cost_packing || "",
      );
      // setValue(
      //   "payment_terms",
      //   res?.data?.payment_term ? res?.data?.payment_term : ""
      // );
      setOrderId(res?.data?.id);

      if (
        res?.data?.payment_term === "N/A" ||
        res?.data?.payment_term === null ||
        res?.data?.payment_term === ""
      ) {
        setValue("payment_terms", 1);
      } else {
        setValue("payment_terms", res?.data?.payment_term);
      }
      setValue(
        "payment_term_detail",
        res?.data?.payment_term_detail ? res?.data?.payment_term_detail : "",
      );
      setValue(
        "shipping_method",
        res?.data?.shipping_method ? res?.data?.shipping_method : "",
      );
      setValue(
        "shipping_terms",
        res?.data?.shipping_term ? res?.data?.shipping_term : "",
      );
      setValue(
        "contractOfficerName",
        res?.data?.orderKo?.name ? res?.data?.orderKo?.name : "",
      );
      setValue(
        "contractOfficerEmail",
        res?.data?.orderKo?.email ? res?.data?.orderKo?.email : "",
      );
      setValue(
        "contractOfficerPhone",
        res?.data?.orderKo?.phone ? res?.data?.orderKo?.phone : "",
      );
      setValue(
        "contractOfficerAddress",
        res?.data?.orderKo?.address ? res?.data?.orderKo?.address : "",
      );
      setValue(
        "shippingCustomerName",
        res?.data?.orderShipping?.name ? res?.data?.orderShipping?.name : "",
      );
      setValue(
        "shippingCustomerPhone",
        res?.data?.orderShipping?.phone ? res?.data?.orderShipping?.phone : "",
      );
      setValue(
        "shippingCustomerEmail",
        res?.data?.orderShipping?.email ? res?.data?.orderShipping?.email : "",
      );
      setValue(
        "shippingCustomerAddress",
        res?.data?.orderShipping?.address
          ? res?.data?.orderShipping?.address
          : "",
      );
      setValue(
        "BillingCustomerName",
        res?.data?.orderBilling?.name ? res?.data?.orderBilling?.name : "",
      );
      setValue(
        "BillingCustomerEmail",
        res?.data?.orderBilling?.email ? res?.data?.orderBilling?.email : "",
      );
      setValue(
        "BillingCustomerPhone",
        res?.data?.orderBilling?.phone ? res?.data?.orderBilling?.phone : "",
      );
      setValue(
        "BillingCustomerAddress",
        res?.data?.orderBilling?.address
          ? res?.data?.orderBilling?.address
          : "",
      );
      setRfqStatus(res?.data?.status);
      // if (res?.data?.attachment_id) {
      //   setFormId(res?.data?.attachment_id);
      // }
      if (res?.data?.attachment_id) {
        updateFormId(res?.data?.attachment_id); // ✅ updates both ref and state
      }
      setValue(
        "sameShipNameasKO",
        res?.data?.is_shipping_same_ko ? res?.data?.is_shipping_same_ko : "",
      );
      setValue(
        "sameBillNameasKO",
        res?.data?.is_billing_same_ko ? res?.data?.is_billing_same_ko : "",
      );
      setValue("Warehouse", res?.data?.initial_consolidation === 1 ? "1" : "0");

      setApiVendor(res?.data);

      res?.data?.OrderVendors.forEach((vendor, index) => {
        setValue(
          `aVendors[${index}].display_name`,
          vendor?.Vendor?.display_name,
        );
        setValue(
          `aVendors[${index}].po_qb_id`,
          vendor?.po_qb_id ? vendor?.po_qb_id : null,
        );
        setValue(
          `aVendors[${index}].bill_qb_id`,
          vendor?.bill_qb_id ? vendor?.bill_qb_id : null,
        );
        setValue(
          `aVendors[${index}].bill_paid`,
          vendor?.bill_paid ? vendor?.bill_paid : null,
        );
        setValue(
          `aVendors[${index}].finance_status_bill`,
          vendor?.finance_status_bill ? vendor?.finance_status_bill : null,
        );
        setValue(
          `aVendors[${index}].finance_status_po`,
          vendor?.finance_status_po ? vendor?.finance_status_po : null,
        );
      });

      setValue("chainOfCustody", res?.data?.OrderChainOfCustodies);

      const initialOriginalVendorsPurchase = {};
      res?.data?.OrderProducts.forEach((product, index) => {
        setValue(`cards[${index}].skuDescription`, product?.description);
        setValue(
          `cards[${index}].vendorPartner`,
          product?.Vendor?.display_name,
        );
        setValue(`cards[${index}].skuId`, product?.sku_display_name);
        setValue(`cards[${index}].skuIdUnique`, product?.sku_id);
        setValue(`cards[${index}].internalSku`, product?.internal_id || "");
        setValue(`cards[${index}].variantId`, product?.variant_id || "");
        setValue(`cards[${index}].rowId`, product?.raw_sku_id);
        setValue(
          `cards[${index}].productName`,
          product?.name ?? product?.Product?.name,
        );
        setValue(
          `cards[${index}].cost`,
          trimTrailingZeros(product?.aspetto_price),
        );
        setValue(
          `cards[${index}].margin`,
          trimTrailingZeros(product?.margin_percent),
        );
        setValue(`cards[${index}].qty`, trimTrailingZeros(product?.quantity));
        setValue(`cards[${index}].um`, product?.unit_of_measure);
        setValue(`cards[${index}].customerCost`, product?.customer_price);
        setValue(`cards[${index}].totalSkuCost`, product?.total_price);
        // if (res?.data?.order_type === "M") {
        //   setValue(
        //     `product_sales[${index}].prodDescription`,
        //     product?.description,
        //   );
        // }
        if (["M", "DS", "CRK", "S"].includes(res?.data?.order_type)) {
          setValue(
            `product_sales[${index}].prodDescription`,
            product?.description,
          );
          setValue(
            `product_sales[${index}].purchaseCost`,
            trimTrailingZeros(product?.total_price),
          );
        }

        // setValue(
        //   `product_sales[${index}].prodDescription`,
        //   product?.description
        // );
        initialOriginalVendorsPurchase[index] =
          product?.Product?.Vendor?.display_name;
      });
      setValue("originalVendorsPurchase", initialOriginalVendorsPurchase);

      const initialOriginalVendors = {};

      res?.data?.OrderProductSales.forEach((product, index) => {
        setValue(
          `product_sales[${index}].skuDescription`,
          product?.description,
        );
        setValue(
          `product_sales[${index}].vendorPartner`,
          product?.Vendor?.display_name,
        );
        setValue(`product_sales[${index}].skuIdUnique`, product?.sku_id);
        setValue(`product_sales[${index}].type`, product?.type);
        setValue(`product_sales[${index}].rowId`, product?.raw_sku_id);
        setValue(`product_sales[${index}].vendorId`, product?.vendor_id);
        setValue(
          `product_sales[${index}].internalSku`,
          product?.internal_id || "",
        );
        setValue(
          `product_sales[${index}].variantId`,
          product?.variant_id || "",
        );
        setValue(`product_sales[${index}].productId`, product?.Product?.id);
        setValue(`product_sales[${index}].clin`, product?.clin_id);
        setValue(
          `product_sales[${index}].productName`,
          product?.name ?? product?.Product?.name,
        );
        setValue(`product_sales[${index}].skuId`, product?.sku_display_name);
        setValue(
          `product_sales[${index}].cost`,
          trimTrailingZeros(product?.aspetto_price),
        );
        setValue(
          `product_sales[${index}].margin`,
          trimTrailingZeros(product?.margin_percent),
        );
        setValue(
          `product_sales[${index}].qty`,
          trimTrailingZeros(product?.quantity),
        );

        // product bound
        setValue(`product_sales[${index}].max_quantity`, product?.max_quantity);

        setValue(
          `product_sales[${index}].ordered_quantity`,
          product?.ordered_quantity,
        );
        setValue(`product_sales[${index}].um`, product?.unit_of_measure);
        setValue(
          `product_sales[${index}].customerCost`,
          product?.customer_price,
        );
        setValue(`product_sales[${index}].totalSkuCost`, product?.total_price);
        initialOriginalVendors[index] = product?.Product?.Vendor?.display_name;
      });
      setValue("originalVendors", initialOriginalVendors);
      if (["M", "CRK", "DS", "S"].includes(res?.data?.order_type)) {
        setValue("shippingCostPurchaseNew", res?.data?.shipping_cost ?? "");
        setValue("taxPurchaseNew", res?.data?.tax ?? "");
        const parsedPurchaseOther = res?.data?.other_cost_json
          ? JSON.parse(res.data.other_cost_json)
          : [];
        parsedPurchaseOther.forEach((c, i) => {
          setValue(`otherCostPurchaseNew[${i}].Name`, c?.Name);
          setValue(`otherCostPurchaseNew[${i}].Amount`, c?.Amount);
        });
      } else {
        setValue("shippingCost", res?.data?.shipping_cost);
        setValue("tax", res?.data?.tax);
        const parsedCosts = res?.data?.other_cost_json
          ? JSON.parse(res.data.other_cost_json)
          : [];
        parsedCosts.forEach((cost, index) => {
          setValue(`otherCost[${index}].Name`, cost?.Name);
          setValue(`otherCost[${index}].Amount`, cost?.Amount);
        });
      }
      // const parsedCosts = res?.data?.other_cost_json
      //   ? JSON.parse(res.data.other_cost_json)
      //   : [];
      // parsedCosts.forEach((cost, index) => {
      //   setValue(`otherCost[${index}].Name`, cost?.Name);
      //   setValue(`otherCost[${index}].Amount`, cost?.Amount);
      // });
      const parsedCostsSales = res?.data?.other_cost_json_sales
        ? JSON.parse(res.data.other_cost_json_sales)
        : [];
      parsedCostsSales.forEach((cost, index) => {
        setValue(`other_cost_json_sales[${index}].Name`, cost?.Name);
        setValue(`other_cost_json_sales[${index}].Amount`, cost?.Amount);
      });
      // setValue("tax", res?.data?.tax);
      setValue("taxsales", res?.data?.tax_sales);
      // setValue("shippingCost", res?.data?.shipping_cost);
      setValue("shippingCostsales", res?.data?.shipping_cost_sales);
      setValue("totalCostAfterMargin", res?.data?.total_cost_after_margin);
      setValue("totalCostBeforeMargin", res?.data?.total_cost_before_margin);
      setValue(
        "totalCostAfterMarginSales",
        res?.data?.total_cost_after_margin_sales,
      );
      setValue(
        "totalCostBeforeMarginSales",
        res?.data?.total_cost_before_margin_sales,
      );
      setInitialVal(0);
      setValue(
        "sales_lead_email",
        res?.data?.sales_lead_email ? res?.data?.sales_lead_email : "",
      );
      setValue(
        "sales_lead_name",
        res?.data?.sales_lead_name ? res?.data?.sales_lead_name : "",
      );
      setValue(
        "sales_lead_username",
        res?.data?.sales_lead_username ? res?.data?.sales_lead_username : "",
      );
      setValue(
        "sales_lead_phone",
        res?.data?.sales_lead_phone ? res?.data?.sales_lead_phone : "",
      );
      const emailsString = res?.data?.team_emails;
      const emailsArray = emailsString ? emailsString.split(",") : [];
      setValue("notification_emails", emailsArray);

      const orderpendingEmailsString =
        res?.data?.order_pending_notification_emails;
      const orderpendingEmailsArray = orderpendingEmailsString
        ? orderpendingEmailsString.split(",")
        : [];
      setValue("orderpending_notification_emails", orderpendingEmailsArray);

      const orderprogressEmailsString =
        res?.data?.order_progress_notification_emails;
      const orderprogressEmailsArray = orderprogressEmailsString
        ? orderprogressEmailsString.split(",")
        : [];
      setValue("orderprogress_notification_emails", orderprogressEmailsArray);
      setValue("notification_emails", emailsArray);
      setValue("notifyEmails", res?.data?.notify_emails === 1 ? "1" : "0");
      setValue(
        "notifyEmailsVendor",
        res?.data?.notify_emails_vendor === 1 ? "1" : "0",
      );

      setValue(
        "estimateddelivery",
        res?.data?.estimated_delivery ? res?.data?.estimated_delivery : "30",
      );

      // skipFirstEffect.current = true
    }
  };

  const onSingleCopySuccess = (res) => {
    if (res?.data) {
      setValue("ordertype", res?.data?.order_type ? res?.data?.order_type : "");
      // setValue("orderStatus", res?.data?.status ? res?.data?.status : "");
      setValue(
        "order_Payment_Type",
        res?.data?.order_payment_type ? res?.data?.order_payment_type : "",
      );
      // setValue("orderId", res?.data?.order_id ? res?.data?.order_id : "");

      setValue(
        "customerPaid",
        res?.data?.customer_paid ? res?.data?.customer_paid : "",
      );

      setValue(
        "contractVehicle",
        res?.data?.contract_type_id ? res?.data?.contract_type_id : null,
      );

      setValue("vehicleId", res?.data?.ContractType?.id);

      setValue(
        "contractVehicletype",
        res?.data?.ContractType?.contract_vehicle_type
          ? res?.data?.ContractType?.contract_vehicle_type
          : null,
      );
      setValue(
        "shipping_method_detail",
        res?.data?.shipping_method_detail
          ? res?.data?.shipping_method_detail
          : null,
      );
      // setValue(
      //   "ProjectID",
      //   res?.data?.project_id ? res?.data?.project_id : null,
      // );
      setValue(
        "organization_name",
        res?.data?.organization_name ? res?.data?.organization_name : "",
      );
      setValue("Order_Description", res?.data?.brief);
      setValue(
        "publishedDate",
        res?.data?.published_date
          ? moment(res?.data?.published_date).format("MM/DD/YYYY")
          : null,
      );
      setValue(
        "estimated_date",
        res?.data?.estimated_date
          ? moment(res?.data?.estimated_date).format("MM/DD/YYYY")
          : "",
      );
      setValue(
        "actual_date",
        res?.data?.actual_date
          ? moment(res?.data?.actual_date).format("MM/DD/YYYY")
          : "",
      );

      // setValue("custom_fields", res?.data?.custom_fields || []);
      const transformedCustomFields = (res?.data?.custom_fields || []).map(
        (field) => {
          if (field.type === "date" && field.value) {
            return {
              ...field,
              value: moment(field.value).format("MM/DD/YYYY"),
            };
          }
          return field;
        },
      );
      setValue("custom_fields", transformedCustomFields);

      setValue("trackingNumber", res?.data?.orderExtra?.tracking_number || "");
      setValue("carrier", res?.data?.orderExtra?.carrier || "");
      setValue("purchaseOrder", res?.data?.orderExtra?.purchase_order || "");
      setValue("deliveryOrder", res?.data?.orderExtra?.delivery_order || "");
      setValue("amendment", res?.data?.orderExtra?.amendment || "");
      setValue(
        "shipDate",
        res?.data?.orderExtra?.ship_date
          ? moment(res?.data?.orderExtra?.ship_date).format("MM/DD/YYYY")
          : null,
      );
      setValue(
        "shippingCostPacking",
        res?.data?.orderExtra?.shipping_cost_packing || "",
      );
      // setValue(
      //   "payment_terms",
      //   res?.data?.payment_term ? res?.data?.payment_term : ""
      // );
      setOrderId(res?.data?.id);

      if (
        res?.data?.payment_term === "N/A" ||
        res?.data?.payment_term === null ||
        res?.data?.payment_term === ""
      ) {
        setValue("payment_terms", 1);
      } else {
        setValue("payment_terms", res?.data?.payment_term);
      }
      setValue(
        "payment_term_detail",
        res?.data?.payment_term_detail ? res?.data?.payment_term_detail : "",
      );
      setValue(
        "shipping_method",
        res?.data?.shipping_method ? res?.data?.shipping_method : "",
      );
      setValue(
        "shipping_terms",
        res?.data?.shipping_term ? res?.data?.shipping_term : "",
      );
      setValue(
        "contractOfficerName",
        res?.data?.orderKo?.name ? res?.data?.orderKo?.name : "",
      );
      setValue(
        "contractOfficerEmail",
        res?.data?.orderKo?.email ? res?.data?.orderKo?.email : "",
      );
      setValue(
        "contractOfficerPhone",
        res?.data?.orderKo?.phone ? res?.data?.orderKo?.phone : "",
      );
      setValue(
        "contractOfficerAddress",
        res?.data?.orderKo?.address ? res?.data?.orderKo?.address : "",
      );
      setValue(
        "shippingCustomerName",
        res?.data?.orderShipping?.name ? res?.data?.orderShipping?.name : "",
      );
      setValue(
        "shippingCustomerPhone",
        res?.data?.orderShipping?.phone ? res?.data?.orderShipping?.phone : "",
      );
      setValue(
        "shippingCustomerEmail",
        res?.data?.orderShipping?.email ? res?.data?.orderShipping?.email : "",
      );
      setValue(
        "shippingCustomerAddress",
        res?.data?.orderShipping?.address
          ? res?.data?.orderShipping?.address
          : "",
      );
      setValue(
        "BillingCustomerName",
        res?.data?.orderBilling?.name ? res?.data?.orderBilling?.name : "",
      );
      setValue(
        "BillingCustomerEmail",
        res?.data?.orderBilling?.email ? res?.data?.orderBilling?.email : "",
      );
      setValue(
        "BillingCustomerPhone",
        res?.data?.orderBilling?.phone ? res?.data?.orderBilling?.phone : "",
      );
      setValue(
        "BillingCustomerAddress",
        res?.data?.orderBilling?.address
          ? res?.data?.orderBilling?.address
          : "",
      );
      const payload = {
        source_attachment_id: res?.data?.attachment_id,
        // target_attachment_id: formId,
        target_attachment_id: formIdRef.current,
        target_module_type: "ORDER",
      };
      copyAttachments(payload);
      // setRfqStatus(res?.data?.status);
      // if (res?.data?.attachment_id) {
      //   setFormId(res?.data?.attachment_id);
      // }
      setValue(
        "sameShipNameasKO",
        res?.data?.is_shipping_same_ko ? res?.data?.is_shipping_same_ko : "",
      );
      setValue(
        "sameBillNameasKO",
        res?.data?.is_billing_same_ko ? res?.data?.is_billing_same_ko : "",
      );
      setValue("Warehouse", res?.data?.initial_consolidation === 1 ? "1" : "0");

      setApiVendor(res?.data);

      res?.data?.OrderVendors.forEach((vendor, index) => {
        setValue(
          `aVendors[${index}].display_name`,
          vendor?.Vendor?.display_name,
        );
        setValue(
          `aVendors[${index}].po_qb_id`,
          vendor?.po_qb_id ? vendor?.po_qb_id : null,
        );
        setValue(
          `aVendors[${index}].bill_qb_id`,
          vendor?.bill_qb_id ? vendor?.bill_qb_id : null,
        );
        setValue(
          `aVendors[${index}].bill_paid`,
          vendor?.bill_paid ? vendor?.bill_paid : null,
        );
        setValue(
          `aVendors[${index}].finance_status_bill`,
          vendor?.finance_status_bill ? vendor?.finance_status_bill : null,
        );
        setValue(
          `aVendors[${index}].finance_status_po`,
          vendor?.finance_status_po ? vendor?.finance_status_po : null,
        );
      });

      setValue("chainOfCustody", res?.data?.OrderChainOfCustodies);

      const initialOriginalVendorsPurchase = {};
      res?.data?.OrderProducts.forEach((product, index) => {
        setValue(`cards[${index}].skuDescription`, product?.description);
        setValue(
          `cards[${index}].vendorPartner`,
          product?.Vendor?.display_name,
        );
        setValue(`cards[${index}].skuId`, product?.sku_display_name);
        setValue(`cards[${index}].internalSku`, product?.internal_id || "");
        setValue(`cards[${index}].variantId`, product?.variant_id || "");
        setValue(`cards[${index}].skuIdUnique`, product?.sku_id);
        setValue(`cards[${index}].rowId`, product?.raw_sku_id);
        setValue(
          `cards[${index}].productName`,
          product?.name ?? product?.Product?.name,
        );
        setValue(
          `cards[${index}].cost`,
          trimTrailingZeros(product?.aspetto_price),
        );
        setValue(
          `cards[${index}].margin`,
          trimTrailingZeros(product?.margin_percent),
        );
        setValue(`cards[${index}].qty`, trimTrailingZeros(product?.quantity));
        setValue(`cards[${index}].um`, product?.unit_of_measure);
        setValue(`cards[${index}].customerCost`, product?.customer_price);
        setValue(`cards[${index}].totalSkuCost`, product?.total_price);
        // if (res?.data?.order_type === "M") {
        //   setValue(
        //     `product_sales[${index}].prodDescription`,
        //     product?.description,
        //   );
        // }
        if (["M", "DS", "CRK", "S"].includes(res?.data?.order_type)) {
          setValue(
            `product_sales[${index}].prodDescription`,
            product?.description,
          );
        }

        // setValue(
        //   `product_sales[${index}].prodDescription`,
        //   product?.description
        // );
        initialOriginalVendorsPurchase[index] =
          product?.Product?.Vendor?.display_name;
      });
      setValue("originalVendorsPurchase", initialOriginalVendorsPurchase);

      const initialOriginalVendors = {};
      res?.data?.OrderProductSales.forEach((product, index) => {
        setValue(
          `product_sales[${index}].skuDescription`,
          product?.description,
        );
        setValue(
          `product_sales[${index}].vendorPartner`,
          product?.Vendor?.display_name,
        );
        setValue(`product_sales[${index}].skuIdUnique`, product?.sku_id);
        setValue(`product_sales[${index}].type`, product?.type);
        setValue(`product_sales[${index}].rowId`, product?.raw_sku_id);
        setValue(`product_sales[${index}].vendorId`, product?.vendor_id);
        setValue(
          `product_sales[${index}].internalSku`,
          product?.internal_id || "",
        );
        setValue(
          `product_sales[${index}].variantId`,
          product?.variant_id || "",
        );
        setValue(`product_sales[${index}].productId`, product?.Product?.id);
        setValue(`product_sales[${index}].clin`, product?.clin_id);
        setValue(
          `product_sales[${index}].productName`,
          product?.name ?? product?.Product?.name,
        );
        setValue(`product_sales[${index}].skuId`, product?.sku_display_name);
        setValue(
          `product_sales[${index}].cost`,
          trimTrailingZeros(product?.aspetto_price),
        );
        setValue(
          `product_sales[${index}].margin`,
          trimTrailingZeros(product?.margin_percent),
        );
        setValue(
          `product_sales[${index}].qty`,
          trimTrailingZeros(product?.quantity),
        );

        // product bound
        setValue(`product_sales[${index}].max_quantity`, product?.max_quantity);

        setValue(
          `product_sales[${index}].ordered_quantity`,
          product?.ordered_quantity,
        );
        setValue(`product_sales[${index}].um`, product?.unit_of_measure);
        setValue(
          `product_sales[${index}].customerCost`,
          product?.customer_price,
        );
        setValue(`product_sales[${index}].totalSkuCost`, product?.total_price);
        initialOriginalVendors[index] = product?.Product?.Vendor?.display_name;
      });

      setValue("originalVendors", initialOriginalVendors);
      // const parsedCosts = res?.data?.other_cost_json
      //   ? JSON.parse(res.data.other_cost_json)
      //   : [];
      // parsedCosts.forEach((cost, index) => {
      //   setValue(`otherCost[${index}].Name`, cost?.Name);
      //   setValue(`otherCost[${index}].Amount`, cost?.Amount);
      // });
      if (["M", "CRK", "DS", "S"].includes(res?.data?.order_type)) {
        setValue("shippingCostPurchaseNew", res?.data?.shipping_cost ?? "");
        setValue("taxPurchaseNew", res?.data?.tax ?? "");
        const parsedPurchaseOther = res?.data?.other_cost_json
          ? JSON.parse(res.data.other_cost_json)
          : [];
        parsedPurchaseOther.forEach((c, i) => {
          setValue(`otherCostPurchaseNew[${i}].Name`, c?.Name);
          setValue(`otherCostPurchaseNew[${i}].Amount`, c?.Amount);
        });
      } else {
        setValue("shippingCost", res?.data?.shipping_cost);
        setValue("tax", res?.data?.tax);
        const parsedCosts = res?.data?.other_cost_json
          ? JSON.parse(res.data.other_cost_json)
          : [];
        parsedCosts.forEach((cost, index) => {
          setValue(`otherCost[${index}].Name`, cost?.Name);
          setValue(`otherCost[${index}].Amount`, cost?.Amount);
        });
      }
      const parsedCostsSales = res?.data?.other_cost_json_sales
        ? JSON.parse(res.data.other_cost_json_sales)
        : [];
      parsedCostsSales.forEach((cost, index) => {
        setValue(`other_cost_json_sales[${index}].Name`, cost?.Name);
        setValue(`other_cost_json_sales[${index}].Amount`, cost?.Amount);
      });
      // setValue("tax", res?.data?.tax);
      setValue("taxsales", res?.data?.tax_sales);
      // setValue("shippingCost", res?.data?.shipping_cost);
      setValue("shippingCostsales", res?.data?.shipping_cost_sales);
      setValue("totalCostAfterMargin", res?.data?.total_cost_after_margin);
      setValue("totalCostBeforeMargin", res?.data?.total_cost_before_margin);
      setValue(
        "totalCostAfterMarginSales",
        res?.data?.total_cost_after_margin_sales,
      );
      setValue(
        "totalCostBeforeMarginSales",
        res?.data?.total_cost_before_margin_sales,
      );
      setInitialVal(0);
      // setValue(
      //   "sales_lead_email",
      //   res?.data?.sales_lead_email ? res?.data?.sales_lead_email : "",
      // );
      // setValue(
      //   "sales_lead_name",
      //   res?.data?.sales_lead_name ? res?.data?.sales_lead_name : "",
      // );
      // setValue(
      //   "sales_lead_username",
      //   res?.data?.sales_lead_username ? res?.data?.sales_lead_username : "",
      // );
      // setValue(
      //   "sales_lead_phone",
      //   res?.data?.sales_lead_phone ? res?.data?.sales_lead_phone : "",
      // );
      const emailsString = res?.data?.team_emails;
      const emailsArray = emailsString ? emailsString.split(",") : [];
      setValue("notification_emails", emailsArray);

      const orderpendingEmailsString =
        res?.data?.order_pending_notification_emails;
      const orderpendingEmailsArray = orderpendingEmailsString
        ? orderpendingEmailsString.split(",")
        : [];
      setValue("orderpending_notification_emails", orderpendingEmailsArray);

      const orderprogressEmailsString =
        res?.data?.order_progress_notification_emails;
      const orderprogressEmailsArray = orderprogressEmailsString
        ? orderprogressEmailsString.split(",")
        : [];
      setValue("orderprogress_notification_emails", orderprogressEmailsArray);
      setValue("notification_emails", emailsArray);
      setValue("notifyEmails", res?.data?.notify_emails === 1 ? "1" : "0");
      setValue(
        "notifyEmailsVendor",
        res?.data?.notify_emails_vendor === 1 ? "1" : "0",
      );

      setValue(
        "estimateddelivery",
        res?.data?.estimated_delivery ? res?.data?.estimated_delivery : "30",
      );

      // skipFirstEffect.current = true
    }
  };

  const { data: Order, postData: fetchSingleOrder } = usePostRequest(
    API_ENDPOINTS.GET_SINGLE_ORDER,
  );

  const { data: attachments, postData: copyAttachments } = usePostRequest(
    API_ENDPOINTS.COPY_ATTACHMENTS,
  );

  const { data: databyProjectId, postData: fetchDataByProjectID } =
    usePostRequest(API_ENDPOINTS.GET_DATA_VIA_PROJECTID);

  const { data: rma, postData: fetchSingleRma } = usePostRequest(
    API_ENDPOINTS.GET_SINGLE_RMA,
  );

  const { data: notesData, postData: fetchNotes } = usePostRequest(
    API_ENDPOINTS.GET_NOTES,
  );

  const refreshOrder = () => {
    fetchSingleOrder(
      { order_id, route_name: "edit" },
      onSingleOrderSuccess,
      // (res) => {
      //   setApiVendor(res.data);
      // }
    );
  };

  const steps = [
    "General",
    "Billing & Shipping",
    "Products (Sales)",
    "Products (Purchasing)",
    // "Chain of Custody",
    // "Finance",
    ...(order_id ? ["Finance"] : []),
    "Attachments",
    "Notes",
    "Communication",
  ];

  const [currentStep, setCurrentStep] = useState(1);

  const methods = useForm({
    resolver: yupResolver(schema),
    mode: "onChange",
    defaultValues: {
      shippingCostEnabled: true,
      shippingCostEnabledsales: true,
      taxEnabled: true,
      taxEnabledsales: true,
      tax: parseFloat("0.00"),
      taxsales: parseFloat("0.00"),
      shippingCost: parseFloat("0.00"),
      shippingCostsales: parseFloat("0.00"),
      originalVendors: {},
      originalVendorsPurchase: {},
      // contractVehicle:"",
      chainOfCustody: [],
    },
  });

  const {
    handleSubmit,
    setError,
    reset,
    setValue,
    watch,
    getValues,
    control,
    formState: { errors },
  } = methods;

  // const isDirty = methods.formState.isDirty;
  // Confirmation popup before leaving the form
  // useNavigationGuard(isDirty);

  const orderPaymentType = watch("order_Payment_Type");
  const contractVehicle = watch("contractVehicle");
  const ordertype = watch("ordertype");
  const totalCostBeforeMargin = watch("totalCostBeforeMargin");
  const totalCostBeforeMarginSales = watch("totalCostBeforeMarginSales");
  console.log("totalCostBeforeMarginSales", totalCostBeforeMarginSales);
  console.log("totalCostBeforeMargin", totalCostBeforeMargin);
  console.log("ordertype", ordertype);
  const isPurchaseMismatch = false;
  // !["M", "CRK", "DS", "S"].includes(ordertype) &&
  // totalCostBeforeMargin != null &&
  // totalCostBeforeMarginSales != null &&
  // totalCostBeforeMargin !== "" &&
  // totalCostBeforeMarginSales !== "" &&
  // roundToMoney(totalCostBeforeMargin) !==
  //   roundToMoney(totalCostBeforeMarginSales);
  const vendorsProduct =
    useWatch({
      control,
      name: ordertype === "KIT" ? "cards" : "product_sales",
    }) || [];

  // const vendorsProduct = useWatch({ control, name: "cards" }) || [];
  const orderTypeSelected = watch("ordertype") || "DS";

  const memoVendorsProduct = useMemo(
    () => vendorsProduct,
    [JSON.stringify(vendorsProduct)],
  );
  const memoApiVendor = useMemo(() => apiVendor, [JSON.stringify(apiVendor)]);
  const memoOrdertype = useMemo(() => ordertype, [ordertype]);
  const memoOrderPaymentType = useMemo(
    () => orderPaymentType,
    [orderPaymentType],
  );

  useEffect(() => {
    if (memoVendorsProduct?.length > 0) {
      const existingAVendors = getValues("aVendors") || [];

      const vendorPartnerNames = new Set(
        memoVendorsProduct.map((v) => v?.vendorPartner?.trim().toLowerCase()),
      );

      // keep existing entries (preserves po_qb_id / bill_qb_id / bill_paid)
      const filteredExistingAVendors = existingAVendors.filter(
        (vendor) =>
          vendor?.display_name &&
          vendorPartnerNames.has(vendor.display_name.trim().toLowerCase()),
      );

      const existingNames = new Set(
        filteredExistingAVendors.map((v) =>
          v.display_name.trim().toLowerCase(),
        ),
      );

      const newNames = new Set();
      const newVendors = memoVendorsProduct.reduce((acc, item) => {
        const rawName = item?.vendorPartner;
        const name = rawName?.trim().toLowerCase();
        if (name && !existingNames.has(name) && !newNames.has(name)) {
          acc.push({ display_name: rawName.trim() });
          newNames.add(name);
        }
        return acc;
      }, []);

      setValue("aVendors", [...filteredExistingAVendors, ...newVendors]);
    } else {
      setValue("aVendors", []);
    }
  }, [memoVendorsProduct, getValues, setValue]);

  const contractOfficerEmail = watch("contractOfficerEmail");
  const billingCustomerEmail = watch("BillingCustomerEmail");
  const shippingCustomerEmail = watch("shippingCustomerEmail");
  const salesLeadEmail = watch("sales_lead_email");

  // useEffect(() => {
  //   if (!order_id) {
  //     const emails = [
  //       contractOfficerEmail,
  //       billingCustomerEmail,
  //       shippingCustomerEmail,
  //       salesLeadEmail,
  //       user?.email,
  //       ...contractEmails,
  //       ...cvEmails,
  //     ]
  //       .filter((email) => !!email?.trim())
  //       .map((email) => email.trim().toLowerCase());

  //     const unique = [...new Set(emails)];

  //     // console.log("Unique Emails:", unique);

  //     setValue("notification_emails", unique);
  //   }
  // }, [
  //   contractOfficerEmail,
  //   billingCustomerEmail,
  //   shippingCustomerEmail,
  //   salesLeadEmail,
  //   user?.email,
  //   contractEmails,
  //   cvEmails,
  // ]);
  // console.log("the change inn products", getValues("product_sales"));

  const onProjectIdError = (err) => {
    reset({
      ProjectID: getValues("ProjectID"),
      chainOfCustody: getValues("chainOfCustody"),
    });
    toast.error(err?.message);
  };

  const onProjectIdSuccess = (res) => {
    if (res?.data) {
      // console.log("order_ref_type", res?.order_ref_type)
      setValue("ordertype", res?.data?.order_type ? res?.data?.order_type : "");
      setValue(
        "order_Payment_Type",
        res?.data?.order_payment_type ? res?.data?.order_payment_type : "",
      );

      setValue(
        "customerPaid",
        res?.data?.customer_paid ? res?.data?.customer_paid : "",
      );

      setValue("attachmentId", res?.data?.attachment_id);

      setValue("vehicleId", res?.data?.ContractType?.id);

      setValue(
        "estimateddelivery",
        res?.data?.estimated_delivery ? res?.data?.estimated_delivery : "30",
      );

      const estimatedDeliveryDays = res?.data?.estimated_delivery;

      if (estimatedDeliveryDays) {
        const daysToAdd = parseInt(estimatedDeliveryDays, 10);
        if (!isNaN(daysToAdd)) {
          const estimatedDate = moment()
            .add(daysToAdd, "days")
            .format("MM/DD/YYYY");
          setValue("estimated_date", estimatedDate);
        }
      }

      setOrder_ref_type(res?.order_ref_type);
      setValue(
        "contractVehicle",
        res?.data?.contract_type_id ? res?.data?.contract_type_id : null,
      );
      setValue("orderId", res?.order_id ? res?.order_id : "N/A");
      setValue(
        "organization_name",
        res?.data?.organization_name ? res?.data?.organization_name : "",
      );
      setValue(
        "shipping_method_detail",
        res?.data?.shipping_method_detail
          ? res?.data?.shipping_method_detail
          : null,
      );
      setValue(
        "publishedDate",
        res?.data?.published_date
          ? moment(res?.data?.published_date).format("MM/DD/YYYY")
          : null,
      );
      setValue("Order_Description", res?.data?.brief);
      // setValue("custom_fields", res?.data?.custom_fields || []);
      const transformedCustomFields = (res?.data?.custom_fields || []).map(
        (field) => {
          if (field.type === "date" && field.value) {
            return {
              ...field,
              value: moment(field.value).format("MM/DD/YYYY"),
            };
          }
          return field;
        },
      );
      setValue("custom_fields", transformedCustomFields);
      setValue(
        "payment_terms",
        res?.data?.payment_term ? res?.data?.payment_term : "",
      );
      setValue(
        "shipping_method",
        res?.data?.shipping_method ? res?.data?.shipping_method : "",
      );
      setValue(
        "shipping_terms",
        res?.data?.shipping_term ? res?.data?.shipping_term : "",
      );

      setValue(
        "contractOfficerName",
        res?.data?.rfqKo?.name ? res?.data?.rfqKo?.name : "",
      );
      setValue(
        "contractOfficerEmail",
        res?.data?.rfqKo?.email ? res?.data?.rfqKo?.email : "",
      );
      setSingleOpprData(res?.data);
      setValue(
        "contractOfficerPhone",
        res?.data?.rfqKo?.phone ? res?.data?.rfqKo?.phone : "",
      );
      setValue(
        "contractOfficerAddress",
        res?.data?.rfqKo?.address ? res?.data?.rfqKo?.address : "",
      );

      setValue(
        "shippingCustomerName",
        res?.data?.rfqShipping?.name ? res?.data?.rfqShipping?.name : "",
      );
      setValue(
        "shippingCustomerPhone",
        res?.data?.rfqShipping?.phone ? res?.data?.rfqShipping?.phone : "",
      );
      setValue(
        "shippingCustomerEmail",
        res?.data?.rfqShipping?.email ? res?.data?.rfqShipping?.email : "",
      );
      setValue(
        "shippingCustomerAddress",
        res?.data?.rfqShipping?.address ? res?.data?.rfqShipping?.address : "",
      );

      const emailsString = res?.data?.team_emails;
      const emailsArray = emailsString ? emailsString.split(",") : [];
      setValue("notification_emails", emailsArray);

      const orderpendingEmailsString =
        res?.data?.order_pending_notification_emails;
      const orderpendingEmailsArray = orderpendingEmailsString
        ? orderpendingEmailsString.split(",")
        : [];
      setValue("orderpending_notification_emails", orderpendingEmailsArray);

      const orderprogressEmailsString =
        res?.data?.order_progress_notification_emails;
      const orderprogressEmailsArray = orderprogressEmailsString
        ? orderprogressEmailsString.split(",")
        : [];
      setValue("orderprogress_notification_emails", orderprogressEmailsArray);

      setValue("notifyEmails", res?.data?.notify_emails === 1 ? "1" : "0");
      setValue(
        "notifyEmailsVendor",
        res?.data?.notify_emails_vendor === 1 ? "1" : "0",
      );

      setValue(
        "sales_lead_email",
        res?.data?.sales_lead_email ? res?.data?.sales_lead_email : "",
      );
      setValue(
        "sales_lead_name",
        res?.data?.sales_lead_name ? res?.data?.sales_lead_name : "",
      );
      setValue(
        "sales_lead_username",
        res?.data?.sales_lead_username ? res?.data?.sales_lead_username : "",
      );

      setValue(
        "sales_lead_phone",
        res?.data?.sales_lead_phone ? res?.data?.sales_lead_phone : "",
      );

      setValue(
        "BillingCustomerName",
        res?.data?.rfqBilling?.name ? res?.data?.rfqBilling?.name : "",
      );
      setValue(
        "BillingCustomerEmail",
        res?.data?.rfqBilling?.email ? res?.data?.rfqBilling?.email : "",
      );
      setValue(
        "BillingCustomerPhone",
        res?.data?.rfqBilling?.phone ? res?.data?.rfqBilling?.phone : "",
      );
      setValue(
        "BillingCustomerAddress",
        res?.data?.rfqBilling?.address ? res?.data?.rfqBilling?.address : "",
      );
      // setRfqStatus(res?.data?.status); // Commented status set to avoid errors while order create
      // if (res?.data?.attachment_id) {
      //   setFormId(res?.data?.attachment_id);
      // }
      setValue(
        "sameShipNameasKO",
        res?.data?.is_shipping_same_ko ? res?.data?.is_shipping_same_ko : "",
      );

      setValue(
        "sameBillNameasKO",
        res?.data?.is_billing_same_ko ? res?.data?.is_billing_same_ko : "",
      );

      // setRfqStatus(res?.data?.status);
      // if (res?.data?.attachment_id) {
      //   setFormId(res?.data?.attachment_id);
      // }

      setValue("Warehouse", res?.data?.initial_consolidation === 1 ? "1" : "0");
      console.log("RfqProducts", res?.data?.RfqProducts);
      // console.log("ordertype received in parent", orderTypeSelected);
      // card  //

      console.log("res?.data?.RfqProducts", res?.data?.RfqProducts);
      const initialOriginalVendorsPurchase = {};
      res?.data?.RfqProducts.forEach((product, index) => {
        // Always set product_sales
        setValue(
          `product_sales[${index}].skuDescription`,
          product?.description,
        );
        setValue(`product_sales[${index}].rowId`, product?.raw_sku_id);
        setValue(`product_sales[${index}].vendorId`, product?.vendor_id);
        setValue(`product_sales[${index}].productId`, product?.Product?.id);
        setValue(
          `product_sales[${index}].prodDescription`,
          product?.purchase_description,
        );
        setValue(
          `product_sales[${index}].vendorPartner`,
          product?.Vendor?.display_name ?? "",
        );
        setValue(
          `product_sales[${index}].productName`,
          product?.name ?? product?.Product?.name,
        );
        setValue(
          `product_sales[${index}].internalSku`,
          product?.internal_id || "",
        );
        setValue(
          `product_sales[${index}].variantId`,
          product?.variant_id || "",
        );
        setValue(`product_sales[${index}].clin`, product?.clin_id);
        setValue(`product_sales[${index}].skuIdUnique`, product?.sku_id);
        setValue(`product_sales[${index}].skuId`, product?.sku_display_name);
        setValue(
          `product_sales[${index}].cost`,
          trimTrailingZeros(product?.aspetto_price),
        );
        setValue(
          `product_sales[${index}].margin`,
          trimTrailingZeros(product?.margin_percent),
        );
        setValue(`product_sales[${index}].type`, product?.Product?.type);
        setValue(`product_sales[${index}].qty`, trimTrailingZeros(product?.quantity));
        setValue(`product_sales[${index}].um`, product?.unit_of_measure);
        setValue(
          `product_sales[${index}].customerCost`,
          product?.customer_price,
        );
        setValue(`product_sales[${index}].totalSkuCost`, product?.total_price);
        initialOriginalVendorsPurchase[index] = product?.display_name;
      });
      setValue("originalVendorsPurchase", initialOriginalVendorsPurchase);

      const parsedCosts = res?.data?.other_cost_json
        ? JSON.parse(res.data.other_cost_json)
        : [];
      parsedCosts.forEach((cost, index) => {
        setValue(`other_cost_json_sales[${index}].Name`, cost?.Name);
        setValue(`other_cost_json_sales[${index}].Amount`, cost?.Amount);
      });
      setValue("taxsales", res?.data?.tax);
      setValue("shippingCostsales", res?.data?.shipping_cost);
      setValue("totalCostAfterMargin", res?.data?.total_cost_after_margin);
      setValue("totalCostBeforeMargin", res?.data?.total_cost_before_margin);
    } else {
      // reset({
      //   ProjectID: getValues("ProjectID"),
      //   chainOfCustody: getValues("chainOfCustody"),
      // });
      const currentProjectID = getValues("ProjectID");
      const currentchainOfCustody = getValues("chainOfCustody");
      reset();
      setValue("chainOfCustody", currentchainOfCustody);
      setValue("ProjectID", currentProjectID);
      //setValue("contractVehicle", null);
    }
  };

  useEffect(() => {
    if (
      memoVendorsProduct.length > 0 &&
      memoOrdertype &&
      memoOrderPaymentType &&
      memoApiVendor
    ) {
      const isInvoiced = memoOrderPaymentType === "invoiced";
      const isPostpaid = memoOrderPaymentType === "post-paid";
      const generatedSteps = generateChainOfCustody(
        memoVendorsProduct,
        memoOrdertype,
        isInvoiced,
        isPostpaid,
        memoApiVendor,
      );

      setValue("chainOfCustody", generatedSteps);
    }
  }, [memoVendorsProduct, memoOrdertype, memoOrderPaymentType, memoApiVendor]);

  // console.log("errors =>", errors);
  const onError = (error) => {
    if (error?.errors) {
      const updatedErrors = {};
      Object.keys(error.errors).forEach((field) => {
        if (error.errors[field]?.message) {
          updatedErrors[field] = {
            message: error.errors[field]?.message,
          };
        }
      });

      setServerErr((prevState) => ({
        ...prevState,
        ...updatedErrors,
      }));
      setShow(true);
    }
    // toast.error(error?.message);
    toast.error(`${error?.message}${error?.error ? ` (${error.error})` : ""}`);
  };

  const { isLoading: createLoading, postData: createORDER } = usePostRequest(
    API_ENDPOINTS.ORDER_CREATE,
  );

  const { isLoading: notesLoading, postData: createNotes } = usePostRequest(
    API_ENDPOINTS.CREATE_NOTES,
  );

  /*
   * Approval process: from In Progress onward an order is locked and edits
   * are submitted as a change request instead of saved directly.
   */
  const { isLoading: changeRequestLoading, postData: submitChangeRequest } =
    usePostRequest(API_ENDPOINTS.CREATE_CHANGE_REQUEST);
  const { postData: fetchChangeRequestStatus } = usePostRequest(
    API_ENDPOINTS.CHANGE_REQUEST_ORDER_STATUS,
  );
  const [changeRequestState, setChangeRequestState] = useState({
    locked: false,
    canRequest: false,
    pendingId: null,
    pendingCount: 0,
    needsApproval: true,
  });
  const isChangeRequestMode = Boolean(order_id) && changeRequestState.locked;
  /* Super admin and the two fixed approvers save straight away. */
  const changeRequestLabel = changeRequestState.needsApproval ? "Submit Change Request" : "Submit";
  /* Requests already waiting do not block a new one — each applies its own changes. */
  const changeRequestBlocked =
    isChangeRequestMode && !changeRequestState.canRequest;

  useEffect(() => {
    if (!order_id) {
      return;
    }
    fetchChangeRequestStatus({ order_id }, (res) =>
      setChangeRequestState({
        locked: Boolean(res?.data?.locked),
        canRequest: Boolean(res?.data?.can_request),
        pendingId: res?.data?.pending_change_request_id || null,
        pendingCount: res?.data?.pending_change_request_count || 0,
        needsApproval: res?.data?.needs_approval !== false,
      }),
    );
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [order_id]);

  const { isLoading: UpdateLoading, postData: updateORDER } = usePostRequest(
    API_ENDPOINTS.UPDATE_ORDER,
  );

  const { isLoading, postData: uploadImage } = usePostRequest(
    API_ENDPOINTS.UPLOAD_RFQ_IMG,
  );

  const formatPhone = (phone) => {
    if (!phone) return null;

    // Check if phone starts with '+'
    const startsWithPlus = phone.startsWith("+");

    // Remove all non-digit characters
    const cleaned = phone.replace(/\D/g, "");

    // Add '+' back if it was there
    return startsWithPlus ? `+${cleaned}` : cleaned ? cleaned : null;
  };

  // console.log("formIdRef.current", formIdRef.current);

  const onSubmit = (data, overrides = {}) => {
    // console.log("data", data);
    const custom_fieldsTransformed = data?.custom_fields?.map((fields) => {
      if (fields?.type === "date") {
        return {
          type: fields?.type,
          value: moment(fields?.value).format("YYYY-MM-DD"),
          field_name: fields?.field_name,
        };
      } else if (fields?.type === "dropdown") {
        return {
          type: fields?.type,
          field_name: fields?.field_name,
          value: fields?.value || "",
          options: Array.isArray(fields?.options) ? fields.options : [], // preserve the options array
        };
      } else {
        return {
          type: fields?.type,
          value: fields?.value,
          field_name: fields?.field_name,
        };
      }
    });

    // console.log("data?.chainOfCustody", data?.chainOfCustody)

    const chainOfCustodytransformed = data?.chainOfCustody?.map((chain) => {
      return {
        name: chain.name,
        check_status: chain?.check_status,
        is_custom: chain?.is_custom,
        is_deleted: chain?.is_deleted,
        person_id: chain?.person_id ? chain.person_id : 0,
        role_id: chain?.role_id ? chain.role_id : 0,
        due_date: chain?.due_date
          ? moment(chain.due_date).format("YYYY-MM-DD")
          : null,
      };
    });

    const combinedForPayload = ["M", "CRK", "DS", "S"].includes(data?.ordertype)
      ? roundToMoney(
          (parseFloat(data?.totalCostBeforeMarginSales) || 0) +
            (parseFloat(data?.shippingCostPurchaseNew) || 0) +
            (parseFloat(data?.taxPurchaseNew) || 0) +
            (data?.otherCostPurchaseNew || []).reduce(
              (s, c) => s + (parseFloat(c?.Amount) || 0),
              0,
            ),
        )
      : null;

    // console.log("data?.aVendors", data?.aVendors);

    const aVendorsTransformed = Array.isArray(data?.aVendors)
      ? data.aVendors.map((vendor) => ({
          display_name: vendor?.display_name ?? null,
          po_qb_id: vendor?.po_qb_id ?? null,
          bill_qb_id: vendor?.bill_qb_id ?? null,
          bill_paid: vendor?.bill_paid ?? null,
          finance_status_bill: vendor?.finance_status_bill ?? null,
          finance_status_po: vendor?.finance_status_po ?? null,
        }))
      : [];

    // if (aVendorsTransformed.length === 0 && order_id) {
    //   console.error("Please update from Finance tab");
    //   toast.error("Please update from Finance tab");
    //   return;
    // }

    // const aVendorsTransformed = data?.aVendors?.map((vendor) => {
    //   return {
    //     display_name: vendor?.display_name ? vendor?.display_name : null,
    //     po_qb_id: vendor?.po_qb_id ? vendor?.po_qb_id : null,
    //     bill_qb_id: vendor?.bill_qb_id ? vendor?.bill_qb_id : null,
    //   };
    // });

    // const transformedProducts = data?.cards?.map((product) => {
    //   return {
    //     vendor_name: product?.vendorPartner,
    //     sku_id: product?.skuId,
    //     description: product?.skuDescription ? product?.skuDescription : null,
    //     quantity: product?.qty ? product?.qty : 0,
    //     aspetto_price: product?.cost ? Number(product?.cost) : 0,
    //     customer_price: product?.customerCost
    //       ? Number(product?.customerCost)
    //       : Number(0),
    //     margin_percent: product?.margin ? Number(product?.margin) : 0,
    //     total_price: product?.totalSkuCost ? Number(product?.totalSkuCost) : 0,
    //     um: product?.um ? product?.um : "EA",
    //   };
    // });

    const orderIdDuplicate = location.state?.orderId;
    const transformedProducts =
      data?.ordertype === "KIT"
        ? data?.cards?.map((product) => ({
            vendor_name: product?.vendorPartner,
            sku_id: product?.skuIdUnique,
            sku_display_name: product?.skuId,
            name: product?.productName ? product?.productName : null,
            internal_id: product?.internalSku || null,
            variant_id: product?.variantId || null,
            raw_sku_id: product?.rowId ? product?.rowId : null,
            description: product?.skuDescription?.trim()
              ? product.skuDescription
              : null,
            quantity: product?.qty ?? 0,
            aspetto_price: Number(product?.cost ?? 0),
            customer_price: Number(product?.customerCost ?? 0),
            margin_percent: Number(product?.margin ?? 0),
            total_price: Number(product?.totalSkuCost ?? 0),
            um: product?.um ?? "EA",
          }))
        : data?.product_sales?.map((product) => ({
            vendor_name: product?.vendorPartner,
            sku_id: product?.skuIdUnique,
            sku_display_name: product?.skuId,
            name: product?.productName ? product?.productName : null,
            internal_id: product?.internalSku || null,
            variant_id: product?.variantId || null,
            raw_sku_id: product?.rowId ? product?.rowId : null,
            description: product?.prodDescription?.trim()
              ? product.prodDescription
              : null,
            quantity: product?.qty ?? 0,
            aspetto_price: Number(product?.cost ?? 0),
            customer_price: Number(product?.customerCost ?? 0),
            margin_percent: Number(product?.margin ?? 0),
            total_price: Number(product?.purchaseCost ?? 0),
            um: product?.um ?? "EA",
          }));

    const validProducts = transformedProducts?.every(
      (p) => p?.sku_display_name && p?.sku_display_name !== "",
    )
      ? transformedProducts
      : [];

    const transformedProductsSales = data?.product_sales?.map((product) => {
      return {
        vendor_name: product?.vendorPartner,
        sku_id: product?.skuIdUnique,
        sku_display_name: product?.skuId,
        name: product?.productName ? product?.productName : null,
        internal_id: product?.internalSku || null,
        variant_id: product?.variantId || null,
        raw_sku_id: product?.rowId ? product?.rowId : null,
        // description: product?.skuDescription ? product?.skuDescription : null,
        description: product?.skuDescription?.trim()
          ? product.skuDescription
          : null,
        clin_id: product?.clin ? product?.clin : null,
        quantity: product?.qty ? product?.qty : 0,
        aspetto_price: product?.cost ? Number(product?.cost) : 0,
        customer_price: product?.customerCost
          ? Number(product?.customerCost)
          : Number(0),
        margin_percent: product?.margin ? Number(product?.margin) : 0,
        total_price: product?.totalSkuCost ? Number(product?.totalSkuCost) : 0,
        um: product?.um ? product?.um : "EA",
        type: product?.type,
      };
    });

    const validTypes = ["project", "opportunity", "rma", "order"];
    const payload = {
      // attachment_id: formId,
      attachment_id: formIdRef.current,
      order_ref_type: validTypes.includes(order_ref_type)
        ? order_ref_type
        : "other",
      customer_paid: data?.customerPaid ? data?.customerPaid : "unpaid",
      order_type: data?.ordertype ? data?.ordertype : null,
      order_payment_type: data?.order_Payment_Type
        ? data?.order_Payment_Type
        : null,
      order_id: data?.orderId ? data?.orderId : null,
      project_id: data?.ProjectID ? data?.ProjectID : null,
      contract_type_id: Number(data?.contractVehicle),
      published_date: data?.publishedDate
        ? moment(data.publishedDate).format("YYYY-MM-DD")
        : null,

      estimated_date: data?.estimated_date
        ? moment(data.estimated_date).format("YYYY-MM-DD")
        : null,

      actual_date: data?.actual_date
        ? moment(data.actual_date).format("YYYY-MM-DD")
        : null,

      organization_name: data?.organization_name
        ? data?.organization_name
        : null,
      brief: data?.Order_Description ? data?.Order_Description : null,
      estimated_delivery: data?.estimateddelivery
        ? data?.estimateddelivery
        : null,
      payment_term: data?.payment_terms ? data?.payment_terms : null,
      payment_term_detail: data?.payment_term_detail
        ? data?.payment_term_detail
        : null,
      shipping_method: data?.shipping_method ? data?.shipping_method : null,
      shipping_method_detail: data?.shipping_method_detail
        ? data?.shipping_method_detail
        : null,
      shipping_term: data?.shipping_terms ? data?.shipping_terms : null,
      valid_for: data?.Valid_For ? data?.Valid_For : null,
      shipping_cost_packing: data?.shippingCostPacking
        ? Number(data?.shippingCostPacking)
        : 0,
      tracking_number: data?.trackingNumber ? data?.trackingNumber : null,
      ship_date: data?.shipDate
        ? moment(data.shipDate).format("YYYY-MM-DD")
        : null,
      delivery_order: data?.deliveryOrder ? data?.deliveryOrder : null,
      purchase_order: data?.purchaseOrder ? data?.purchaseOrder : null,
      shipping_cost_sales: data?.shippingCostsales
        ? Number(data?.shippingCostsales)
        : 0,
      amendment: data?.amendment ? data?.amendment : null,
      carrier: data?.carrier ? data?.carrier : null,
      // shipping_cost: data?.shippingCost ? Number(data?.shippingCost) : 0,
      // tax: data?.tax,
      shipping_cost: ["M", "CRK", "DS", "S"].includes(data?.ordertype)
        ? data?.shippingCostPurchaseNew
          ? Number(data?.shippingCostPurchaseNew)
          : 0
        : data?.shippingCost
          ? Number(data?.shippingCost)
          : 0,

      tax: ["M", "CRK", "DS", "S"].includes(data?.ordertype)
        ? data?.taxPurchaseNew
          ? Number(data?.taxPurchaseNew)
          : 0
        : data?.tax,

      otherCost: ["M", "CRK", "DS", "S"].includes(data?.ordertype)
        ? data?.otherCostPurchaseNew || []
        : data?.otherCost,
      tax_sales: data?.taxsales,
      initial_consolidation: Number(data?.Warehouse),

      // total_cost_before_margin: ["M", "CRK", "DS", "S"].includes(
      //   data?.ordertype,
      // )
      //   ? data?.totalCostBeforeMarginSales
      //     ? Number(data?.totalCostBeforeMarginSales)
      //     : 0
      //   : data?.totalCostBeforeMargin
      //     ? Number(data?.totalCostBeforeMargin)
      //     : 0,

      // total_cost_before_margin: ["M", "CRK", "DS", "S"].includes(
      //   data?.ordertype,
      // )
      //   ? data?.combinedTotalCost != null && data?.combinedTotalCost !== ""
      //     ? Number(data?.combinedTotalCost)
      //     : data?.totalCostBeforeMarginSales
      //       ? Number(data?.totalCostBeforeMarginSales)
      //       : 0
      //   : data?.totalCostBeforeMargin
      //     ? Number(data?.totalCostBeforeMargin)
      //     : 0,

      total_cost_after_margin: ["M", "CRK", "DS", "S"].includes(data?.ordertype)
        ? data?.totalCostAfterMarginSales
          ? Number(data?.totalCostAfterMarginSales)
          : 0
        : data?.totalCostAfterMargin
          ? Number(data?.totalCostAfterMargin)
          : 0,
      // total_cost_before_margin_sales: data?.totalCostBeforeMarginSales
      //   ? Number(data?.totalCostBeforeMarginSales)
      //   : 0,

      total_cost_before_margin: ["M", "CRK", "DS", "S"].includes(
        data?.ordertype,
      )
        ? (combinedForPayload ?? 0)
        : data?.totalCostBeforeMargin
          ? Number(data?.totalCostBeforeMargin)
          : 0,

      total_cost_before_margin_sales: ["M", "CRK", "DS", "S"].includes(
        data?.ordertype,
      )
        ? (combinedForPayload ?? 0)
        : data?.totalCostBeforeMarginSales
          ? Number(data?.totalCostBeforeMarginSales)
          : 0,

      total_cost_after_margin_sales: data?.totalCostAfterMarginSales
        ? Number(data?.totalCostAfterMarginSales)
        : 0,
      // total_cost_after_dicscount: 0.0,
      sales_lead_name: data?.sales_lead_name ? data?.sales_lead_name : null,
      sales_lead_email: data?.sales_lead_email ? data?.sales_lead_email : null,
      sales_lead_phone: data?.sales_lead_phone ? data?.sales_lead_phone : null,
      sales_lead_username: data?.sales_lead_username,
      team_emails: data?.notification_emails?.length
        ? data.notification_emails.join(",")
        : null,
      order_pending_notification_emails: data?.orderpending_notification_emails
        ?.length
        ? data.orderpending_notification_emails.join(",")
        : null,
      order_progress_notification_emails: data
        ?.orderprogress_notification_emails?.length
        ? data.orderprogress_notification_emails.join(",")
        : null,
      notify_emails: data?.notifyEmails ? data?.notifyEmails : 0,
      notify_emails_vendor: data?.notifyEmailsVendor
        ? data?.notifyEmailsVendor
        : 0,

      // otherCost: data?.otherCost,
      otherCostSales: data?.other_cost_json_sales,
      // status: rfqstatus ? rfqstatus : "PAYMENT_PENDING",
      // status: rfqstatus
      //   ? rfqstatus
      //   : data?.order_Payment_Type === "pre-paid"
      //   ? "DRAFT"
      //   : "PENDING",
      status: rfqstatus ? rfqstatus : "PENDING",

      // status: overrides.force_status || rfqstatus || "PENDING",
      // status: "PENDING",
      ko_detail: {
        name: data?.contractOfficerName ? data?.contractOfficerName : null,
        email: data?.contractOfficerEmail ? data?.contractOfficerEmail : null,
        phone: formatPhone(data?.contractOfficerPhone),
        // phone: data?.contractOfficerPhone ? data?.contractOfficerPhone : null,
        address: data?.contractOfficerAddress
          ? data?.contractOfficerAddress
          : null,
      },
      shipping_detail: {
        name: data?.shippingCustomerName ? data?.shippingCustomerName : null,
        email: data?.shippingCustomerEmail ? data?.shippingCustomerEmail : null,
        phone: formatPhone(data?.shippingCustomerPhone),
        // phone: data?.shippingCustomerPhone ? data?.shippingCustomerPhone : null,
        address: data?.shippingCustomerAddress
          ? data?.shippingCustomerAddress
          : null,
      },
      billing_detail: {
        name: data?.BillingCustomerName ? data?.BillingCustomerName : null,
        email: data?.BillingCustomerEmail ? data?.BillingCustomerEmail : null,
        phone: formatPhone(data?.BillingCustomerPhone),
        // phone: data?.BillingCustomerPhone ? data?.BillingCustomerPhone : null,
        address: data?.BillingCustomerAddress
          ? data?.BillingCustomerAddress
          : null,
      },
      // products: [...transformedProducts],
      products: [...(validProducts ?? [])],
      product_sales: [...transformedProductsSales],
      aVendors: [...aVendorsTransformed],
      chain_of_custody: chainOfCustodytransformed,
      custom_fields: custom_fieldsTransformed,
      price_changes: data?.price_changes || null,
      qb_id: singleOpprData?.qb_id
        ? singleOpprData.qb_id
        : apiVendor?.qb_id || null,
      transaction_id: singleOpprData?.transaction_id
        ? singleOpprData.transaction_id
        : apiVendor?.transaction_id || null,
    };

    // console.log("payload",payload)

    const onSuccess = (res) => {
      posthog.capture("order_created", {
        order_id: res?.order_id,
        contract_type: res?.contract_type,
        created_by: user?.email,
      });

      const orderIdDuplicate = location.state?.orderId;
      const rfqIdFromState = location.state?.rfqId;
      const rfqAttachmentId = watch("attachmentId");
      console.log("rfqAttachmentId", rfqAttachmentId);
      const rfqProjectId = watch("ProjectID");
      if (rfqIdFromState || (rfqProjectId && !orderIdDuplicate)) {
        console.log("rfqIdFromState", rfqIdFromState, rfqProjectId);
        const payload = {
          source_attachment_id: rfqAttachmentId,
          target_attachment_id: formIdRef.current,
          // target_attachment_id: formId,
          target_module_type: "ORDER",
        };
        copyAttachments(payload);
      }
      const notesPayload = {
        module_id: res?.order_id,
        module_type: "ORDER",
        notes: data.notes,
      };

      if (Array.isArray(notesPayload.notes) && notesPayload.notes.length > 0) {
        createNotes(notesPayload);
      }
      setIsModalOpen({
        show: true,
        title: "Order Created Successfully!",
        message: `Prepared by ${user?.username}. Order ID is ${res.order_id}. This Order is for ${res?.contract_type}.`,
        btntext: "Return Home",
      });
      // reset();
      // localStorage.removeItem("rfqId");
    };

    const onSuccessUpdate = (res) => {
      posthog.capture("order_updated", {
        order_id: res?.order_id,
        contract_type: res?.contract_type,
        created_by: user?.email,
      });

      // const notesPayload = {
      //   module_id: res?.order_id,
      //   module_type: "ORDER",
      //   notes: data.notes,
      // };
      // if (Array.isArray(notesPayload.notes) && notesPayload.notes.length > 0) {
      //   createNotes(notesPayload);
      // }
      setIsModalOpen({
        show: true,
        title: "Order Updated Successfully!",
        message: `Updated by ${user?.username}. Order ID is ${res.order_id}. This Order is for ${res?.contract_type}.`,
        btntext: "Return Home",
      });
      reset();
    };
    const onChangeRequestSuccess = (res) => {
      const applied = Boolean(res?.data?.applied);
      posthog.capture(applied ? "order_updated" : "order_change_request_submitted", {
        order_id,
        created_by: user?.email,
      });
      if (!applied) {
        setChangeRequestState((current) => ({
          ...current,
          pendingId: res?.data?.change_request?.id || current.pendingId,
          pendingCount: (current.pendingCount || 0) + 1,
        }));
      }
      setIsModalOpen(
        applied
          ? {
              show: true,
              title: "Order Updated Successfully!",
              message: res?.message,
              btntext: "Return Home",
            }
          : {
              show: true,
              title: "Change Request Submitted",
              message: res?.message,
              btntext: "View Change Requests",
              primaryTo: "/change-requests",
              newbtn: "Go Home",
              secondaryTo: "/",
            },
      );
    };

    if (Order && order_id && isChangeRequestMode) {
      submitChangeRequest(
        { module_type: "ORDER", order_id, payload },
        onChangeRequestSuccess,
        onError,
      );
    } else if (Order && order_id) {
      updateORDER(payload, onSuccessUpdate, onError);
    } else {
      createORDER(payload, onSuccess, onError, API_ENDPOINTS.ORDER_CREATE);
    }
  };

  // useEffect(() => {
  //   if (orderCopy && !orderDataFetchedcopy) {
  //     let order_id = orderCopy;
  //     fetchSingleOrder({ order_id }, onCopyOrderSuccess);
  //     setOrderDataFetchedcopy(true);
  //   } else {
  //     setInitialVal(0);
  //   }
  // }, [orderCopy, orderDataFetchedcopy, fetchSingleOrder]);

  useEffect(() => {
    if (order_id && !orderDataFetched) {
      fetchSingleOrder({ order_id, route_name: "edit" }, onSingleOrderSuccess);
      setOrderDataFetched(true);
      setIsEditing(true);
    }
    // else {
    //   console.log("YE CHALA")
    //   setInitialVal(0);
    // }
  }, [order_id, orderDataFetched, fetchSingleOrder]);

  useEffect(() => {
    if (order_id && !orderDataFetched) {
      fetchNotes(
        {
          module_id: order_id,
          module_type: "ORDER",
        },
        onSingleNotesSuccess,
      );
    }
  }, [order_id, fetchNotes]);

  const handleProjectIDBlur = () => {
    const value = getValues("ProjectID");
    if (value.length > 0) {
      fetchDataByProjectID(
        { project_id: value },
        onProjectIdSuccess,
        onProjectIdError,
      );
    }
  };

  const handleOrderIDBlur = () => {
    const value = getValues("orderId");
    if (value.length > 0) {
      fetchSingleRma(
        { rma_id: value },
        onRmaIdSuccess,
        // onRmaIdError
      );
    }
  };

  const handleStepChange = useCallback(
    (type) => {
      if (type === "next") {
        const currentData = methods.getValues();

        console.log("currentData", currentData);
        const fieldsToValidate = getFieldsForCurrentStep(currentStep);
        methods.trigger(fieldsToValidate).then((isValid) => {
          if (isValid) {
            if (currentStep === 4 && isPurchaseMismatch) return;
            if (currentStep <= steps.length - 1) {
              console.log("Errors:", methods.formState.errors);
              setCurrentStep((prev) => prev + 1);
            }
          } else {
            console.log("Errors:", methods.formState.errors);
          }
        });
      } else {
        if (currentStep > 1) {
          setCurrentStep((prev) => prev - 1);
        }
      }
    },
    [currentStep, methods],
  );

  // useEffect(() => {
  //   const handleKeyDown = (event) => {
  //     if (event.key === "ArrowRight") {
  //       handleStepChange("next");
  //     } else if (event.key === "ArrowLeft") {
  //       handleStepChange("prev");
  //     }
  //   };

  //   document.addEventListener("keydown", handleKeyDown);
  //   return () => {
  //     document.removeEventListener("keydown", handleKeyDown);
  //   };
  // }, [handleStepChange]);

  // if (order_id) {
  //   steps.push("Communication");
  // }

  useEffect(() => {
    if (user && !isEditing) {
      setValue("sales_lead_name", `${user?.first_name} ${user?.last_name}`);
      setValue("sales_lead_email", user?.email);
      setValue("sales_lead_phone", user?.phone);
      setValue("sales_lead_username", user?.username);
    }
  }, [user]);

  const handleTabChange = (tabIndex) => {
    if (order_id) {
      const fieldsToValidate = getFieldsForCurrentStep(currentStep);
      methods.trigger(fieldsToValidate).then((isValid) => {
        if (isValid) {
          setCurrentStep(tabIndex);
        } else {
          console.log("Validation failed for step:", currentStep);
        }
      });
    }
  };

  const getFieldsForCurrentStep = (step, rfq_id) => {
    switch (step) {
      case 1:
        return [
          "opportunityName",
          "orderId",
          "ProjectID",
          "ordertype",
          "order_Payment_Type",
          "organization_name",
          "Order_Description",
          "publishedDate",
          "estimated_date",
          "actual_date",
          "contractVehicle",
          "custom_fields",
        ];
      case 2:
        return [
          "shipping_method_detail",
          "payment_term_detail",

          "contractOfficerName",
          "contractOfficerEmail",
          "contractOfficerPhone",
          "contractOfficerAddress",

          "shippingCustomerName",
          "shippingCustomerEmail",
          "shippingCustomerPhone",
          "shippingCustomerAddress",

          "BillingCustomerName",
          "BillingCustomerEmail",
          "BillingCustomerPhone",
          "BillingCustomerAddress",
        ];
      case 3:
        return ["product_sales", "otherCostSales"];
      case 4:
        return ["cards", "otherCost"];
      case 5:
        return [];
      case 6:
        return [];
      case 7:
        return ["notes"];
      case 7:
        return [
          // "sales_lead_username",
          "sales_lead_phone",
          "sales_lead_email",
          "sales_lead_name",
        ];

      default:
        return [];
    }
  };

  useEffect(() => {
    const newFormId = generateUniqueId();
    updateFormId(newFormId);
    // setFormId(newFormId);
    // reset();
    reset({
      ...getValues(),
      sales_lead_name: `${user?.first_name} ${user?.last_name}`,
      sales_lead_email: user?.email,
      sales_lead_phone: user?.phone,
      sales_lead_username: user?.username,
    });
  }, []);

  useEffect(() => {
    const orderIdDuplication = location.state?.orderId;
    if (orderIdDuplication) {
      // setValue("orderId", orderIdDuplication || "");
      fetchSingleOrder(
        { order_id: orderIdDuplication, is_duplicate: "yes" },
        onSingleCopySuccess,
      );
    }
  }, [location.state]);

  useEffect(() => {
    const rfqIdFromState = location.state?.rfqId;
    if (rfqIdFromState) {
      setValue("ProjectID", rfqIdFromState || "");
      fetchDataByProjectID(
        { project_id: rfqIdFromState },
        onProjectIdSuccess,
        onProjectIdError,
      );
    }
  }, [location.state]);

  // useEffect(() => {
  //   const storedRfqId = localStorage.getItem("rfqId");
  //   if (storedRfqId) {
  //     setValue("ProjectID", storedRfqId || "");
  //     fetchDataByProjectID(
  //       { project_id: storedRfqId },
  //       onProjectIdSuccess,
  //       onProjectIdError
  //     );
  //   } else {
  //     return;
  //   }
  // }, []);

  const orderTypeLabels = {
    DS: "Dropship",
    CRK: "Consolidate / Repack",
    M: "Manufacturing",
    KIT: "Kit",
    S: "Stock",
  };

  return (
    <>
      <SuccsessMsgModal
        show={isModalOpen.show}
        onHide={() =>
          setIsModalOpen(
            { ...isModalOpen, show: false },
            navigate(isModalOpen.primaryTo || "/list-order-lifecycle"),
          )
        }
        title={isModalOpen.title}
        btntext={isModalOpen.btntext}
        message={isModalOpen.message}
        newbtn={isModalOpen.newbtn}
        onSecondaryBtnClick={() =>
          setIsModalOpen(
            { ...isModalOpen, show: false },
            navigate(isModalOpen.secondaryTo || "/"),
          )
        }
      />

      <div className="page-header">
        <div className=" d-flex justify-content-between  align-items-center">
          <div>
            <h2 className="page-title">
              {isEditing ? (
                <>
                  {isChangeRequestMode && changeRequestState.needsApproval
                    ? "Change Request"
                    : "Update Order"}
                </>
              ) : (
                <>
                  Create
                  <span style={{ color: "#f76707", margin: "0 4px" }}>
                    {orderTypeLabels[ordertype]}
                  </span>
                  Order
                </>
              )}
            </h2>
          </div>

          <div className="d-flex gap-2">
            {!isEditing && (
              <div className="d-flex flex-row gap-2 align-items-center">
                <h2 className="page-title">Status: </h2>
                <p className="mb-0 fw-bold">PO PENDING</p>
                <Form.Control
                  type="text"
                  value="PENDING"
                  readOnly
                  style={{ display: "none" }}
                />
              </div>
            )}

            {currentStep === 1 && contractVehicle === "9" && !isEditing && (
              <Button
                className="d-flex align-items-center gap-2 px-4 py-2"
                style={{
                  backgroundColor: "#f76707",
                  border: "none",
                  borderRadius: "8px",
                }}
                onClick={() => setIsPDFOpen({ show: true })}
              >
                <IconCloudUpload size={20} /> <strong>Upload GSA PDF</strong>
              </Button>
            )}
          </div>
          {/* <div>
            <Form.Group>
              <InputGroup>
                <Form.Select
                  className={`Status_select`}
                  // value={rfqstatus}
                  // onChange={handleStatusChange}
                >
                  <option value="DRAFT">DRAFT</option>
                  <option value="PENDING">PENDING</option>
                  <option value="IN PROGRESS">IN PROGRESS</option>
                  <option value="REACHED_WAREHOUSE">AT WAREHOUSE</option>
                  <option value="SHIPPED">SHIPPED</option>
                  <option value="DELIVERED">DELIVERED</option>
                  <option value="PAID_CLOSED">PAID & CLOSED</option>
                </Form.Select>
              </InputGroup>
            </Form.Group>
          </div> */}
        </div>
      </div>

      {isChangeRequestMode &&
        (changeRequestState.needsApproval ||
          !changeRequestState.canRequest ||
          changeRequestState.pendingCount > 0) && (
        <Alert
          variant={changeRequestBlocked ? "warning" : "info"}
          className="d-flex align-items-start gap-2"
        >
          <IconInfoCircle stroke={1.5} size={20} className="flex-shrink-0 mt-1" />
          <div>
            {!changeRequestState.canRequest ? (
              <>This order is Lost/Cancelled and can no longer be changed.</>
            ) : (
              <>
                {changeRequestState.needsApproval ? (
                  <>
                    This order is In Progress or later, so edits need approval.
                    Make your changes and choose{" "}
                    <strong>Submit Change Request</strong> — the Head of Sales
                    and the Head of Finance both review it before anything
                    changes.
                  </>
                ) : null}
                {changeRequestState.pendingCount > 0 && (
                  <div className="mt-1">
                    {changeRequestState.pendingCount === 1
                      ? "1 change request for this order is already waiting for approval — you can still send another."
                      : `${changeRequestState.pendingCount} change requests for this order are already waiting for approval — you can still send another.`}{" "}
                    <Link to={`/change-requests?id=${changeRequestState.pendingId}`}>
                      View requests
                    </Link>
                  </div>
                )}
              </>
            )}
          </div>
        </Alert>
      )}

      <Card>
        <Card.Body className="pt-3 pb-4 pt-md-5 pb-md-5">
          <Stepper
            steps={steps}
            currentStep={currentStep}
            onTabClick={order_id ? handleTabChange : undefined}
          />
          <FormProvider
            {...methods}
            className=""
            onSubmit={methods.handleSubmit(onSubmit)}
          >
            <Form autoComplete="off" onSubmit={methods.handleSubmit(onSubmit)}>
              {currentStep === 1 && (
                <GsaPdfModal show={isPDFOpen.show} setShow={setIsPDFOpen} />
              )}

              {currentStep === 1 && (
                <GeneralInfo
                  order_ref_type={order_ref_type}
                  isEditing={isEditing}
                  onProjectIDBlur={handleProjectIDBlur}
                  onOrderIDBlur={handleOrderIDBlur}
                  setCvEmails={setCvEmails}
                />
              )}

              {/* {currentStep === 2 && <CustodyChainForm />} */}
              {currentStep === 2 && (
                <BillingAndShippingForm initialVal={initialVal} />
              )}
              {currentStep === 3 && (
                <ProductsSales
                  order_ref_type={order_ref_type}
                  isEditing={order_id}
                  orderId={orderId}
                />
              )}
              {currentStep === 4 && (
                <OrderDetailsForm
                  order_ref_type={order_ref_type}
                  isEditing={order_id}
                />
              )}

              {/* {currentStep === 5 && (
                <CustodyChainForm
                  setApiVendor={setApiVendor}
                  apiVendor={apiVendor}
                  qbId={singleOpprData?.qb_id}
                  status={rfqstatus}
                />
              )} */}

              {order_id && currentStep === 5 && (
                <VendorForm
                  apiVendor={apiVendor}
                  orderId={order_id}
                  onRefresh={refreshOrder}
                  status={rfqstatus}
                />
              )}

              {currentStep === (order_id ? 6 : 5) && (
                <Attachments attachmnetid={formId} status={rfqstatus} />
              )}
              {currentStep === (order_id ? 7 : 6) && (
                <NotesSection status={rfqstatus} />
              )}
              {currentStep === (order_id ? 8 : 7) && <SalesLead />}
              {/* {currentStep === 6 && (
                <VendorForm
                  apiVendor={apiVendor}
                  orderId={order_id}
                  onRefresh={refreshOrder}
                />
              )}
              {currentStep === 7 && (
                <Attachments attachmnetid={formId} status={rfqstatus} />
              )}
              {currentStep === 8 && <NotesSection status={rfqstatus} />}
              {currentStep === 9 && <SalesLead />} */}

              <div className="server_error">
                {show && (
                  <>
                    <Alert
                      variant="danger"
                      onClose={() => setShow(false)}
                      dismissible
                    >
                      <Alert.Heading>Validation Errors!</Alert.Heading>
                      {Object.keys(serverErr).map((field) => (
                        <p
                          key={field}
                          style={{ color: "red", marginBottom: "5px" }}
                        >
                          {serverErr[field]?.message}
                        </p>
                      ))}
                    </Alert>
                  </>
                )}
              </div>

              <div className="d-flex justify-content-center gap-3 mt-3">
                {currentStep > 1 && (
                  <Button
                    variant="outline-secondary"
                    onClick={() => handleStepChange("prev")}
                  >
                    <IconArrowNarrowLeftDashed /> Back
                  </Button>
                )}
                {order_id
                  ? currentStep < steps.length && (
                      <Button
                        variant="warning"
                        onClick={() => handleStepChange("next")}
                        disabled={currentStep === 4 && isPurchaseMismatch}
                      >
                        Next <IconArrowNarrowRightDashed />
                      </Button>
                    )
                  : currentStep < steps.length && (
                      <Button
                        variant="warning"
                        onClick={() => handleStepChange("next")}
                        disabled={currentStep === 4 && isPurchaseMismatch}
                      >
                        Next <IconArrowNarrowRightDashed />
                      </Button>
                    )}

                {order_id
                  ? currentStep < steps.length &&
                    canShowButtons && (
                      <div className="d-flex">
                        <Button
                          variant="success"
                          type="submit"
                          disabled={isPurchaseMismatch || changeRequestBlocked || changeRequestLoading}
                        >
                          {createLoading || UpdateLoading || changeRequestLoading ? (
                            <Spinner
                              as="span"
                              animation="border"
                              size="sm"
                              role="status"
                              aria-hidden="true"
                            />
                          ) : isChangeRequestMode ? (
                            changeRequestLabel
                          ) : (
                            "Update"
                          )}
                        </Button>
                      </div>
                    )
                  : null}

                {currentStep === steps.length && canShowButtons && (
                  <div className="d-flex">
                    <Button
                      variant="warning"
                      type="submit"
                      disabled={
                        createLoading || UpdateLoading || isPurchaseMismatch ||
                        changeRequestBlocked || changeRequestLoading
                      }
                    >
                      {createLoading || UpdateLoading || changeRequestLoading ? (
                        <Spinner
                          as="span"
                          animation="border"
                          size="sm"
                          role="status"
                          aria-hidden="true"
                        />
                      ) : isChangeRequestMode ? (
                        changeRequestLabel
                      ) : (
                        "Submit"
                      )}
                    </Button>
                  </div>
                )}

                {/* {currentStep === 9 && !order_id && (
                  <div className="d-flex">
                    <Button
                      className="flex-grow-1"
                      variant="outline-secondary"
                      disabled={createLoading || UpdateLoading}
                      onClick={() => {
                        methods.handleSubmit((data) =>
                          onSubmit(data, { force_status: "DRAFT" })
                        )();
                      }}
                      // onClick={() => {
                      //   setRfqStatus("DRAFT");
                      //   methods.handleSubmit(onSubmit)();
                      // }}
                    >
                      {createLoading || UpdateLoading ? (
                        <Spinner
                          as="span"
                          animation="border"
                          size="sm"
                          role="status"
                          aria-hidden="true"
                        />
                      ) : (
                        "Save as Draft"
                      )}
                    </Button>
                  </div>
                )} */}
              </div>
              {isPurchaseMismatch && (
                <div
                  class="invalid-feedback d-flex  mt-2 totle_costing align-items-center justify-content-center"
                  style={{ fontSize: "15px" }}
                >
                  Total cost of Sales and Purchase Tabs do not match. Please
                  review the entered info.
                </div>
              )}
            </Form>
          </FormProvider>
        </Card.Body>
      </Card>
    </>
  );
}

export default CreateLifeCycle;
